var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon, _polygon2, _path, _polygon3, _polygon4, _path2, _polygon5, _polygon6, _path3, _polygon7, _polygon8, _path4, _polygon9, _polygon10, _path5, _polygon11, _polygon12, _path6, _polygon13, _polygon14, _path7, _polygon15, _polygon16, _circle, _polygon17, _polygon18, _circle2, _polygon19, _polygon20, _circle3, _polygon21, _polygon22, _circle4, _polygon23, _polygon24, _path8, _polygon25, _polygon26, _path9, _polygon27, _polygon28, _path10, _polygon29, _polygon30, _path11, _polygon31, _polygon32, _path12, _polygon33, _polygon34, _path13, _polygon35, _polygon36, _path14, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path15, _path16, _path17, _path18, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _path19, _polygon52, _polygon53, _path20, _polygon54, _polygon55, _path21, _polygon56, _polygon57, _circle11, _polygon58, _polygon59, _path22, _polygon60, _polygon61, _circle12, _polygon62, _polygon63, _circle13, _polygon64, _polygon65, _circle14, _polygon66, _polygon67, _path23, _polygon68, _polygon69, _path24, _polygon70, _polygon71, _path25, _polygon72, _polygon73, _path26, _polygon74, _polygon75, _path27, _polygon76, _polygon77, _polygon78, _path28, _polygon79, _polygon80, _polygon81, _path29, _polygon82, _polygon83, _polygon84, _path30, _polygon85, _polygon86, _polygon87, _path31, _circle15, _circle16, _path32, _path33, _path34, _circle17, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _circle18, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _circle19, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _circle20, _path90, _path91, _path92, _path93, _circle21, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _circle22, _path120, _g, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g2, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _polygon88, _g3, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _circle23, _circle24, _path176, _ellipse, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _polygon89, _path207, _path208, _path209, _path210, _path211, _path212, _polygon90, _path213, _path214, _path215, _path216, _path217, _path218, _polygon91, _g4, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 367.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#e0e0e0;}.c{fill:#f5f5f5;}.d{fill:#263238;}.e,.f,.g,.i,.j,.m,.o,.r,.t,.u{fill:#fff;}.e,.f,.i,.j,.k,.l,.m,.o,.p,.r,.s,.t,.u{isolation:isolate;}.e,.k{opacity:0.1;}.f,.l,.n{opacity:0.2;}.h{fill:#407bff;}.i,.p,.q{opacity:0.5;}.j{opacity:0.6;}.m{opacity:0.7;}.o,.s{opacity:0.3;}.r{opacity:0.4;}.t{opacity:0.8;}.u{opacity:0.9;}.v{fill:#ebb376;}.w{fill:#d58745;}.x{fill:#de5753;}.aa,.y,.z{fill:none;}.y{stroke:#263238;stroke-width:1.18px;}.aa,.y{stroke-miterlimit:10;}.z{stroke:#407bff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.55px;}.aa{stroke:#fff;stroke-width:0.59px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    y: 308.5,
    width: 500,
    height: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 416.8,
    y: 324.6,
    width: 33.1,
    height: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 322.5,
    y: 327.4,
    width: 8.7,
    height: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 396.6,
    y: 315.4,
    width: 19.2,
    height: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 52.5,
    y: 317,
    width: 43.2,
    height: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 104.6,
    y: 317,
    width: 6.3,
    height: 0.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 131.5,
    y: 321.3,
    width: 93.7,
    height: 0.25
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "396.5 36.2 401.9 37.1 396.5 37.9 395.7 43.3 394.8 37.9 389.4 37.1 394.8 36.2 395.7 30.8 396.5 36.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "396.9 37.1 400.1 41.5 395.7 38.3 391.3 41.5 394.4 37.1 391.3 32.7 395.7 35.8 400.1 32.7 396.9 37.1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.9,55.9a1.3,1.3,0,0,1-1.2,1.3,1.3,1.3,0,0,1-1.3-1.3,1.2,1.2,0,0,1,1.2-1.2h.1a1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -18.9)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "434 242.8 439.3 243.7 434 244.6 433.1 249.9 432.2 244.6 426.9 243.7 432.2 242.8 433.1 237.5 434 242.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "434.3 243.7 437.5 248.1 433.1 244.9 428.7 248.1 431.9 243.7 428.7 239.3 433.1 242.5 437.5 239.3 434.3 243.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M434.3,262.6a1.2,1.2,0,1,1-2.4,0h0a1.2,1.2,0,1,1,2.4,0Z",
    transform: "translate(0 -18.9)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "137.9 319.8 143.2 320.7 137.9 321.6 137 326.9 136.1 321.6 130.8 320.7 136.1 319.8 137 314.5 137.9 319.8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "138.3 320.7 141.4 325.1 137 321.9 132.6 325.1 135.8 320.7 132.6 316.3 137 319.5 141.4 316.3 138.3 320.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.3,339.5a1.3,1.3,0,0,1-1.3,1.3,1.2,1.2,0,0,1-1.2-1.2h0a1.2,1.2,0,0,1,1.2-1.2h0A1.3,1.3,0,0,1,138.3,339.5Z",
    transform: "translate(0 -18.9)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "329.1 14.1 334.5 15 329.1 15.9 328.3 21.2 327.4 15.9 322 15 327.4 14.1 328.3 8.8 329.1 14.1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "329.5 15 332.7 19.4 328.3 16.2 323.9 19.4 327 15 323.9 10.6 328.3 13.7 332.7 10.6 329.5 15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.5,33.8a1.3,1.3,0,0,1-1.2,1.3,1.3,1.3,0,0,1-1.3-1.3,1.3,1.3,0,0,1,1.3-1.2A1.3,1.3,0,0,1,329.5,33.8Z",
    transform: "translate(0 -18.9)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "371.1 106.4 376.4 107.3 371.1 108.2 370.2 113.5 369.3 108.2 364 107.3 369.3 106.4 370.2 101.1 371.1 106.4"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "371.5 107.3 374.6 111.7 370.2 108.5 365.8 111.7 369 107.3 365.8 102.9 370.2 106.1 374.6 102.9 371.5 107.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.5,126.1a1.3,1.3,0,0,1-1.3,1.3,1.2,1.2,0,0,1-1.2-1.2h0a1.2,1.2,0,0,1,1.2-1.2h0A1.3,1.3,0,0,1,371.5,126.1Z",
    transform: "translate(0 -18.9)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "370.5 309.6 375.8 310.5 370.5 311.4 369.6 316.7 368.7 311.4 363.4 310.5 368.7 309.6 369.6 304.3 370.5 309.6"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "370.8 310.5 374 314.9 369.6 311.7 365.2 314.9 368.3 310.5 365.2 306.1 369.6 309.2 374 306.1 370.8 310.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.8,329.3a1.2,1.2,0,0,1-1.1,1.3h-.1a1.3,1.3,0,0,1-1.3-1.3,1.3,1.3,0,0,1,1.3-1.2,1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -18.9)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "59.9 195.2 64.4 196 59.9 196.7 59.2 201.3 58.4 196.7 53.9 196 58.4 195.2 59.2 190.7 59.9 195.2"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "60.2 196 62.9 199.7 59.2 197 55.4 199.7 58.1 196 55.4 192.3 59.2 194.9 62.9 192.3 60.2 196"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.2,214.8a1.1,1.1,0,0,1-1,1.1,1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1A1.1,1.1,0,0,1,60.2,214.8Z",
    transform: "translate(0 -18.9)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "389.1 198.6 393.6 199.4 389.1 200.1 388.3 204.6 387.6 200.1 383 199.4 387.6 198.6 388.3 194.1 389.1 198.6"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "389.4 199.4 392 203.1 388.3 200.4 384.6 203.1 387.3 199.4 384.6 195.6 388.3 198.3 392 195.6 389.4 199.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 388.3,
    cy: 199.4,
    r: 1.1
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "437.4 107.5 441.9 108.3 437.4 109 436.6 113.6 435.9 109 431.4 108.3 435.9 107.5 436.6 103 437.4 107.5"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "437.7 108.3 440.4 112 436.6 109.3 432.9 112 435.6 108.3 432.9 104.6 436.6 107.2 440.4 104.6 437.7 108.3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 436.6,
    cy: 108.3,
    r: 1.1
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "122.6 17 127.2 17.8 122.6 18.5 121.9 23.1 121.2 18.5 116.6 17.8 121.2 17 121.9 12.5 122.6 17"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "123 17.8 125.6 21.5 121.9 18.8 118.2 21.5 120.8 17.8 118.2 14.1 121.9 16.7 125.6 14.1 123 17.8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 121.9,
    cy: 17.8,
    r: 1.1
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "151.6 224.1 156.1 224.9 151.6 225.6 150.9 230.1 150.1 225.6 145.6 224.9 150.1 224.1 150.9 219.6 151.6 224.1"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "151.9 224.9 154.6 228.6 150.9 225.9 147.1 228.6 149.8 224.9 147.1 221.1 150.9 223.8 154.6 221.1 151.9 224.9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 150.9,
    cy: 224.9,
    r: 1.1
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "247.5 305.5 252 306.2 247.5 306.9 246.7 311.5 246 306.9 241.4 306.2 246 305.5 246.7 300.9 247.5 305.5"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "247.8 306.2 250.4 309.9 246.7 307.3 243 309.9 245.7 306.2 243 302.5 246.7 305.1 250.4 302.5 247.8 306.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.8,325.1a1.1,1.1,0,0,1-1.1,1,.9.9,0,0,1-1-1,1,1,0,0,1,.9-1.1h.1a1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(0 -18.9)"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "294.4 95.5 299 96.2 294.4 96.9 293.7 101.5 292.9 96.9 288.4 96.2 292.9 95.5 293.7 90.9 294.4 95.5"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "294.7 96.2 297.4 99.9 293.7 97.3 290 99.9 292.6 96.2 290 92.5 293.7 95.1 297.4 92.5 294.7 96.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M294.7,115.1a.9.9,0,0,1-1,1,1.1,1.1,0,0,1-1.1-1,1.1,1.1,0,0,1,1.1-1.1h0a.9.9,0,0,1,1,1Z",
    transform: "translate(0 -18.9)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "87.6 73 92.9 73.9 87.6 74.8 86.7 80.1 85.8 74.8 80.5 73.9 85.8 73 86.7 67.7 87.6 73"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "88 73.9 91.1 78.3 86.7 75.1 82.3 78.3 85.5 73.9 82.3 69.5 86.7 72.7 91.1 69.5 88 73.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88,92.8A1.3,1.3,0,0,1,86.7,94a1.3,1.3,0,0,1-.1-2.5h.1A1.3,1.3,0,0,1,88,92.8Z",
    transform: "translate(0 -18.9)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "214.2 5.3 219.5 6.2 214.2 7.1 213.3 12.4 212.4 7.1 207.1 6.2 212.4 5.3 213.3 0 214.2 5.3"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "214.5 6.2 217.7 10.6 213.3 7.4 208.9 10.6 212 6.2 208.9 1.8 213.3 5 217.7 1.8 214.5 6.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.5,25.1a1.2,1.2,0,0,1-2.4,0h0a1.2,1.2,0,1,1,2.4,0Z",
    transform: "translate(0 -18.9)"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "180.1 116.9 185.4 117.8 180.1 118.7 179.2 124 178.3 118.7 173 117.8 178.3 116.9 179.2 111.6 180.1 116.9"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "180.4 117.8 183.6 122.2 179.2 119.1 174.8 122.2 177.9 117.8 174.8 113.4 179.2 116.6 183.6 113.4 180.4 117.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M180.4,136.7a1.2,1.2,0,0,1-1.2,1.2,1.3,1.3,0,0,1-1.3-1.2,1.3,1.3,0,0,1,1.3-1.3h0a1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -18.9)"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "97.7 285.8 103 286.7 97.7 287.6 96.8 293 95.9 287.6 90.6 286.7 95.9 285.8 96.8 280.5 97.7 285.8"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "98 286.7 101.2 291.1 96.8 288 92.4 291.1 95.6 286.7 92.4 282.3 96.8 285.5 101.2 282.3 98 286.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98,305.6a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,98,305.6Z",
    transform: "translate(0 -18.9)"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "313.5 219.6 318.9 220.5 313.5 221.3 312.7 226.7 311.8 221.3 306.4 220.5 311.8 219.6 312.7 214.2 313.5 219.6"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "313.9 220.5 317.1 224.9 312.7 221.7 308.3 224.9 311.4 220.5 308.3 216.1 312.7 219.2 317.1 216.1 313.9 220.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M313.9,239.3a1.2,1.2,0,0,1-1.2,1.2h0a1.2,1.2,0,0,1,0-2.4h0A1.2,1.2,0,0,1,313.9,239.3Z",
    transform: "translate(0 -18.9)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 167.7,
    cy: 37,
    r: 17
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 420.7,
    cy: 159.8,
    r: 17
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 283,
    cy: 329.6,
    r: 17
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 356.8,
    cy: 67.3,
    r: 9.8,
    transform: "translate(209.2 380.1) rotate(-76.7)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 244.8,
    cy: 241.3,
    r: 9.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 100.9,
    cy: 227,
    r: 9.8,
    transform: "translate(-131 118.9) rotate(-45)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M235.4,24.3c84-2.5,193.2,82.2,193,205.6,0,66.7-102,168.5-204.5,155.2S73.1,285.3,66.4,215.3,108.1,28.1,235.4,24.3Z",
    transform: "translate(0 -18.9)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M275.2,56.3c-56.6-8.9-112.8,22.4-111.3,29.4s14.9,1.6,22.8,1.6-34.2,28.3-38.4,44.6,40-32.2,80-40,22.6-11.7,19.8-18.1,39.6-13.6,72.6,3.1,52.6,40.6,61.7,55C382.4,131.9,360.5,69.8,275.2,56.3Z",
    transform: "translate(0 -18.9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M260.3,127.5c2.6-13.4,36.8-15.8,62.2,1.7s29.3,36.5,23.7,35.9,23.3,15.1,33.6,52.8-.6,81.6-33.6,106.1c0,0,21.7-22.3,17.8-63.2s-50.5-49.1-59.9-60.3-2.1-28.1,15.1-30.8,2.6-23.6-16-24.2-33,3.9-35.6.4-49.3,4.5-58.6,40.3-22.7,25.4-14.4,0,62.4-50.7,72.5-52.5S259.7,130.6,260.3,127.5Z",
    transform: "translate(0 -18.9)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M148,182.4c18.7-8.8-1.2,37.3,4.7,80.8s59,79,97.3,74.8,62.1-56,32.5-75.7c0,0,30.1,1.5,36.7,32.5s-9,59-31.8,60.6-34.7,16.3-43.3,16,3.2-4.7-1.6-10.9-38.9-.6-80.2-20-50-39.2-57.7-67,8.9,4.4,17.4-.9.7-19.1,1.7-32.7,7-26.6,15.1-17.5S139,186.6,148,182.4Z",
    transform: "translate(0 -18.9)"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "124.3 267.7 125.2 266.4 124 267.3 123.7 265.8 123.5 267.3 122.2 266.4 123.1 267.7 121.6 267.9 123.1 268.2 122.2 269.4 123.5 268.5 123.7 270 124 268.5 125.2 269.4 124.3 268.2 125.8 267.9 124.3 267.7"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "391.6 239 392.5 237.7 391.3 238.6 391 237.1 390.8 238.6 389.5 237.7 390.4 239 388.9 239.2 390.4 239.5 389.5 240.7 390.8 239.8 391 241.3 391.3 239.8 392.5 240.7 391.6 239.5 393.1 239.2 391.6 239"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "259.4 288.3 260.3 287.1 259 288 258.8 286.5 258.5 288 257.3 287.1 258.2 288.3 256.7 288.6 258.2 288.8 257.3 290.1 258.5 289.2 258.8 290.7 259 289.2 260.3 290.1 259.4 288.8 260.9 288.6 259.4 288.3"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "133.9 231 135.4 228.8 133.3 230.4 132.9 227.8 132.4 230.4 130.3 228.8 131.8 231 129.2 231.4 131.8 231.8 130.3 234 132.4 232.4 132.9 235 133.3 232.4 135.4 234 133.9 231.8 136.5 231.4 133.9 231"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "99.5 163.4 101 161.2 98.9 162.8 98.5 160.2 98 162.8 95.9 161.2 97.4 163.4 94.8 163.8 97.4 164.2 95.9 166.4 98 164.8 98.5 167.4 98.9 164.8 101 166.4 99.5 164.2 102.1 163.8 99.5 163.4"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "275.7 39 277.2 36.9 275.1 38.4 274.6 35.8 274.2 38.4 272.1 36.9 273.6 39 271 39.4 273.6 39.9 272.1 42 274.2 40.5 274.6 43.1 275.1 40.5 277.2 42 275.7 39.9 278.3 39.4 275.7 39"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "307.3 163.1 308.8 161 306.6 162.5 306.2 159.9 305.8 162.5 303.6 161 305.2 163.1 302.6 163.5 305.2 164 303.6 166.1 305.8 164.6 306.2 167.2 306.6 164.6 308.8 166.1 307.3 164 309.9 163.5 307.3 163.1"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "228.5 43.3 230.1 41.1 227.9 42.7 227.5 40 227.1 42.7 224.9 41.1 226.5 43.3 223.9 43.7 226.5 44.1 224.9 46.3 227.1 44.7 227.5 47.3 227.9 44.7 230.1 46.3 228.5 44.1 231.1 43.7 228.5 43.3"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "232.7 244.4 235.3 240.8 231.6 243.4 230.9 238.9 230.2 243.4 226.5 240.8 229.1 244.4 224.7 245.2 229.1 245.9 226.5 249.6 230.2 246.9 230.9 251.4 231.6 246.9 235.3 249.6 232.7 245.9 237.1 245.2 232.7 244.4"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "362.1 70.3 357.7 69.6 360.3 65.9 356.6 68.6 355.9 64.1 355.2 68.6 351.5 65.9 354.1 69.6 349.7 70.3 354.1 71.1 351.5 74.7 355.2 72.1 355.9 76.6 356.6 72.1 360.3 74.7 357.7 71.1 362.1 70.3"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "222.2 99.7 224.8 96 221.1 98.6 220.4 94.2 219.7 98.6 216 96 218.6 99.7 214.2 100.4 218.6 101.1 216 104.8 219.7 102.2 220.4 106.6 221.1 102.2 224.8 104.8 222.2 101.1 226.6 100.4 222.2 99.7"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "352.4 276.2 355 272.5 351.3 275.2 350.6 270.7 349.9 275.2 346.2 272.5 348.8 276.2 344.4 276.9 348.8 277.7 346.2 281.3 349.9 278.7 350.6 283.2 351.3 278.7 355 281.3 352.4 277.7 356.8 276.9 352.4 276.2"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "147.3 82.8 142.8 82.1 145.4 78.4 141.8 81 141 76.6 140.3 81 136.6 78.4 139.3 82.1 134.8 82.8 139.3 83.5 136.6 87.2 140.3 84.6 141 89 141.8 84.6 145.4 87.2 142.8 83.5 147.3 82.8"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "124 267.6 125.8 267.9 124 268.2 123.7 270 123.4 268.2 121.6 267.9 123.4 267.6 123.7 265.8 124 267.6"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "124.1 267.9 125.2 269.4 123.7 268.4 122.2 269.4 123.3 267.9 122.2 266.4 123.7 267.5 125.2 266.4 124.1 267.9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M124.1,286.8a.4.4,0,1,1-.4-.4A.4.4,0,0,1,124.1,286.8Z",
    transform: "translate(0 -18.9)"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "391.3 238.9 393.1 239.2 391.3 239.5 391 241.3 390.7 239.5 388.9 239.2 390.7 238.9 391 237.1 391.3 238.9"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "391.4 239.2 392.5 240.7 391 239.6 389.5 240.7 390.6 239.2 389.5 237.7 391 238.8 392.5 237.7 391.4 239.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M391.4,258.1a.4.4,0,1,1-.4-.4C391.3,257.7,391.4,257.8,391.4,258.1Z",
    transform: "translate(0 -18.9)"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "259.1 288.3 260.9 288.6 259.1 288.9 258.8 290.7 258.5 288.9 256.7 288.6 258.5 288.3 258.8 286.5 259.1 288.3"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "259.2 288.6 260.3 290.1 258.8 289 257.3 290.1 258.4 288.6 257.3 287.1 258.8 288.2 260.3 287.1 259.2 288.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M259.2,307.4c0,.2-.2.5-.4.5s-.4-.2-.4-.5a.4.4,0,0,1,.8,0Z",
    transform: "translate(0 -18.9)"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "133.4 230.9 136.5 231.4 133.4 231.9 132.9 235 132.3 231.9 129.2 231.4 132.3 230.9 132.9 227.8 133.4 230.9"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "133.6 231.4 135.4 234 132.9 232.1 130.3 234 132.1 231.4 130.3 228.8 132.9 230.7 135.4 228.8 133.6 231.4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 132.9,
    cy: 231.4,
    r: 0.7
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "99 163.3 102.1 163.8 99 164.3 98.5 167.4 97.9 164.3 94.8 163.8 97.9 163.3 98.5 160.2 99 163.3"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "99.2 163.8 101 166.4 98.5 164.5 95.9 166.4 97.7 163.8 95.9 161.2 98.5 163.1 101 161.2 99.2 163.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M99.2,182.6a.8.8,0,0,1-.7.8.9.9,0,0,1-.8-.8.8.8,0,0,1,.8-.7A.7.7,0,0,1,99.2,182.6Z",
    transform: "translate(0 -18.9)"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "275.1 38.9 278.3 39.4 275.1 40 274.6 43.1 274.1 40 271 39.4 274.1 38.9 274.6 35.8 275.1 38.9"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "275.4 39.4 277.2 42 274.6 40.2 272.1 42 273.9 39.4 272.1 36.9 274.6 38.7 277.2 36.9 275.4 39.4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 274.6,
    cy: 39.4,
    r: 0.7
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "306.7 163 309.9 163.5 306.7 164.1 306.2 167.2 305.7 164.1 302.6 163.5 305.7 163 306.2 159.9 306.7 163"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "306.9 163.5 308.8 166.1 306.2 164.3 303.6 166.1 305.5 163.5 303.6 161 306.2 162.8 308.8 161 306.9 163.5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 306.2,
    cy: 163.5,
    r: 0.7
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "228 43.2 231.1 43.7 228 44.2 227.5 47.3 227 44.2 223.9 43.7 227 43.2 227.5 40 228 43.2"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "228.2 43.7 230.1 46.3 227.5 44.4 224.9 46.3 226.8 43.7 224.9 41.1 227.5 43 230.1 41.1 228.2 43.7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 227.5,
    cy: 43.7,
    r: 0.7
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "231.8 244.3 237.1 245.2 231.8 246 230.9 251.4 230 246 224.7 245.2 230 244.3 230.9 238.9 231.8 244.3"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "232.1 245.2 235.3 249.6 230.9 246.4 226.5 249.6 229.7 245.2 226.5 240.8 230.9 243.9 235.3 240.8 232.1 245.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M232.1,264a1.2,1.2,0,1,1-2.4,0h0a1.2,1.2,0,1,1,2.4,0Z",
    transform: "translate(0 -18.9)"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "356.8 69.5 362.1 70.3 356.8 71.2 355.9 76.6 355 71.2 349.7 70.3 355 69.5 355.9 64.1 356.8 69.5"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "357.1 70.3 360.3 74.7 355.9 71.6 351.5 74.7 354.6 70.3 351.5 65.9 355.9 69.1 360.3 65.9 357.1 70.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M357.1,89.2a1.2,1.2,0,1,1-1.2-1.2,1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -18.9)"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "221.3 99.5 226.6 100.4 221.3 101.3 220.4 106.6 219.5 101.3 214.2 100.4 219.5 99.5 220.4 94.2 221.3 99.5"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "221.7 100.4 224.8 104.8 220.4 101.6 216 104.8 219.2 100.4 216 96 220.4 99.1 224.8 96 221.7 100.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M221.6,119.2a1.2,1.2,0,1,1-2.4,0h0a1.2,1.2,0,1,1,2.4,0Z",
    transform: "translate(0 -18.9)"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "351.5 276.1 356.8 276.9 351.5 277.8 350.6 283.2 349.7 277.8 344.4 276.9 349.7 276.1 350.6 270.7 351.5 276.1"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "351.8 276.9 355 281.3 350.6 278.2 346.2 281.3 349.3 276.9 346.2 272.5 350.6 275.7 355 272.5 351.8 276.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M351.8,295.8a1.2,1.2,0,1,1-1.2-1.2,1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(0 -18.9)"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "141.9 81.9 147.3 82.8 141.9 83.7 141 89 140.2 83.7 134.8 82.8 140.2 81.9 141 76.6 141.9 81.9"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "142.3 82.8 145.4 87.2 141 84 136.6 87.2 139.8 82.8 136.6 78.4 141 81.6 145.4 78.4 142.3 82.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M142.3,101.6a1.3,1.3,0,0,1-1.3,1.3h0a1.3,1.3,0,0,1-1.2-1.3,1.3,1.3,0,0,1,1.2-1.2A1.3,1.3,0,0,1,142.3,101.6Z",
    transform: "translate(0 -18.9)"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "280.1 337.5 275.6 336.8 278.2 333.1 274.6 335.7 273.8 331.3 273.1 335.7 269.4 333.1 272.1 336.8 267.6 337.5 272.1 338.2 269.4 341.9 273.1 339.3 273.8 343.7 274.6 339.3 278.2 341.9 275.6 338.2 280.1 337.5"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "274.7 336.6 280.1 337.5 274.7 338.4 273.8 343.7 273 338.4 267.6 337.5 273 336.6 273.8 331.3 274.7 336.6"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "275.1 337.5 278.2 341.9 273.8 338.7 269.4 341.9 272.6 337.5 269.4 333.1 273.8 336.3 278.2 333.1 275.1 337.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M275.1,356.4a1.3,1.3,0,0,1-1.3,1.2,1.3,1.3,0,0,1-1.2-1.2,1.3,1.3,0,0,1,1.2-1.3A1.3,1.3,0,0,1,275.1,356.4Z",
    transform: "translate(0 -18.9)"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "84.3 217.6 85.2 216.4 83.9 217.3 83.7 215.8 83.4 217.3 82.2 216.4 83.1 217.6 81.6 217.9 83.1 218.1 82.2 219.4 83.4 218.5 83.7 220 83.9 218.5 85.2 219.4 84.3 218.1 85.8 217.9 84.3 217.6"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "84 217.6 85.8 217.9 84 218.2 83.7 220 83.4 218.2 81.6 217.9 83.4 217.6 83.7 215.8 84 217.6"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "84.1 217.9 85.2 219.4 83.7 218.3 82.2 219.4 83.3 217.9 82.2 216.4 83.7 217.5 85.2 216.4 84.1 217.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M84.1,236.7a.4.4,0,1,1-.4-.4.4.4,0,0,1,.4.4Z",
    transform: "translate(0 -18.9)"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "204.4 193.6 205.3 192.4 204 193.3 203.8 191.8 203.5 193.3 202.3 192.4 203.2 193.6 201.6 193.9 203.2 194.1 202.3 195.4 203.5 194.5 203.8 196 204 194.5 205.3 195.4 204.4 194.1 205.9 193.9 204.4 193.6"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "204.1 193.6 205.9 193.9 204.1 194.2 203.8 196 203.5 194.2 201.6 193.9 203.5 193.6 203.8 191.8 204.1 193.6"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "204.2 193.9 205.3 195.4 203.8 194.3 202.3 195.4 203.3 193.9 202.3 192.4 203.8 193.5 205.3 192.4 204.2 193.9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M204.2,212.7c0,.2-.2.5-.4.5a.5.5,0,0,1-.5-.5c0-.2.3-.4.5-.4A.4.4,0,0,1,204.2,212.7Z",
    transform: "translate(0 -18.9)"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "163.3 139.6 164.2 138.4 163 139.2 162.7 137.7 162.5 139.2 161.2 138.4 162.1 139.6 160.6 139.8 162.1 140.1 161.2 141.3 162.5 140.4 162.7 142 163 140.4 164.2 141.3 163.3 140.1 164.8 139.8 163.3 139.6"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "163 139.5 164.8 139.8 163 140.1 162.7 142 162.4 140.1 160.6 139.8 162.4 139.5 162.7 137.7 163 139.5"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "163.2 139.8 164.2 141.3 162.7 140.3 161.2 141.3 162.3 139.8 161.2 138.4 162.7 139.4 164.2 138.4 163.2 139.8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M163.2,158.7c0,.2-.3.4-.5.4a.4.4,0,1,1,0-.8h0C162.9,158.3,163.2,158.5,163.2,158.7Z",
    transform: "translate(0 -18.9)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 152.9,
    cy: 38.2,
    r: 12.7
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 152.9,
    cy: 38.2,
    r: 12.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M140.2,58c1.6-.8,2.3-1.4,2.2-.6a8.9,8.9,0,0,0,0,2.3.9.9,0,0,0,1,.3c.8-.3.8-.4,1.1-.4s2.5.1,1.8.9-.4,1.2-1,1.4-.8,1-.9,1.1l-.6.7-1.4.6a8.4,8.4,0,0,0,1.5,1.8l1,.9a2.8,2.8,0,0,1,1.2-.4c.7,0,.8.3,1.2.5s.3,0,.3,0a.6.6,0,0,0,.7.2c.3-.2,1.6,0,1.8,0s1.2-.4,1.6-.1.6.2.6.6a2.5,2.5,0,0,1-.5,1.9,10.8,10.8,0,0,0,4-.2c-.6-.4-.3-2.4-.8-3.3s-.4-1.1-.2-1.5.5,0,.7,0a.9.9,0,0,0,.9-.9,5.9,5.9,0,0,1,.2-1.3s.5-.9.7-.9a2.1,2.1,0,0,0,1.1,0c.3-.2.3-.3.4-.6s.1-1.6-.1-1.5l-.9-.3-1-.2c-.1.1-.2-.5-.2-.5s1.1-.6,1.1-.8-.4-.3-.5-.9.5-.7,1.1-.6,0,.3,0,.8.1.5.7,0,.5,0,.7,0l1,.2a12.2,12.2,0,0,0,0,2.7c.1,1.4,2.1.1,2.7-.4s1.1-.2,1.9.2a12.9,12.9,0,0,0-2-9.9s-.1.1-.1,0-1,.2-1.2,0-.9.2-1.2,0a1.4,1.4,0,0,1-.7-1.2,6.6,6.6,0,0,0-.6-2c0-.2-.1-.4,0-.4a12.8,12.8,0,0,0-10.3-1.3c.5.8.9,1.7.4,2.1a1.4,1.4,0,0,0,.2,2,.9.9,0,0,1,.1,1.3h-.1c-.2.2-.6.8-.2,1s1.1.6.6,1-.3,1.1-1.2.4-.6-1.4-1.3-1.4-.9.9-1.8,1.1-1,.3-1.2.1a7.2,7.2,0,0,0-.9-1.4,1.1,1.1,0,0,0-1.3,0c0,.1-.1.1-.1.2s-.3,1.5,0,1.7-.1,1-.6,1.2-1.1-.7-1.3-.1h-.1A16.2,16.2,0,0,0,140.2,58Zm13.1,6.1c-.9.3,0,0-.9-1s.5-.3.5-.3a9.4,9.4,0,0,0,.4-1.6c.1-.6.9,0,1.4,0s.9.7.3,1.6.1.5-.3.4S154.2,63.9,153.3,64.1Zm-.4,1.5c.2-.1.9.2.8,1l-.9.2-.7-.7c-.3-.4.5-.3.8-.5Zm-6.8-9.8a.9.9,0,0,1,.6-1c.7-.2.9.5,1.6.5s.3,1.8.3,1.8.2.8-.9.5-1.7,0-1.8-.4S146.1,56.4,146.1,55.8Z",
    transform: "translate(0 -18.9)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M173.2,51.7a2,2,0,0,1-2,2,1.9,1.9,0,0,1-1.9-1.9h0a2,2,0,0,1,3.9,0Z",
    transform: "translate(0 -18.9)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.2,51.7a2,2,0,0,1-2,2,1.9,1.9,0,0,1-1.9-1.9h0a2,2,0,0,1,3.9,0Z",
    transform: "translate(0 -18.9)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 170.3,
    cy: 33.5,
    r: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M172.1,51.6h0c-.1,0-.1,0-.1-.1h.1Z",
    transform: "translate(0 -18.9)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M171.1,53.2h-.2c0-.1,0-.1.1-.1s.1,0,.1.1Z",
    transform: "translate(0 -18.9)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M171.8,50.1c0,.1,0,.1-.1.1h0c-.1,0-.1,0-.1-.1Z",
    transform: "translate(0 -18.9)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M173,51.8c0,.1,0,.1-.1.1h.1Z",
    transform: "translate(0 -18.9)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M170,51.2h0Z",
    transform: "translate(0 -18.9)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M171,50.7c0,.1-.1.2-.3.2l-.2-.2c0-.2.1-.3.2-.3a.3.3,0,0,1,.3.3Z",
    transform: "translate(0 -18.9)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M172.4,52.9a.3.3,0,0,1-.3.3h0c-.1,0-.2-.1-.2-.3a.2.2,0,0,1,.2-.2C172.3,52.7,172.4,52.8,172.4,52.9Z",
    transform: "translate(0 -18.9)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M426.6,196.2a8.2,8.2,0,1,1-6.2,9.8A8.2,8.2,0,0,1,426.6,196.2Z",
    transform: "translate(0 -18.9)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M426.6,196.2a8.2,8.2,0,1,1-6.2,9.8A8.2,8.2,0,0,1,426.6,196.2Z",
    transform: "translate(0 -18.9)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M435.8,200.6c-.1.2-.3-.1-.8.2a2.9,2.9,0,0,1-1.6.4l-.2.2c-.1.2-1.1-.1-1.1-.5s0,0,.8-.3,0,0,.1-.5-.3-.3-.6-.7-.4-.3-.7-.1-.2.4-.4.5l-.3.2h-.7c-.1,0-.1.1-.1.2h-.3V200h0l.2-.3h.3a.4.4,0,0,0-.1-.3h.3c.1,0,.3-.6.3-.7s0-.2-.1-.2h-.3c-.2,0-.3-.3-.5-.2h-.2l-.2.2h-.3c.2,0,0,.2-.1.2a1.1,1.1,0,0,1-.8-.1h-.2c0-.1-.1-.3-.1-.4s-.2-.7.1-.8.5,0,.6-.3h0c.1-.1.2,0,.2.1s-.1.4,0,.5.2.3.4.2h0c-.1-.1.1-.3.2-.3h.4c.1,0,.2-.2.2-.3a.8.8,0,0,0-.2-.4h-.5c-.1-.1-.3-.3-.4-.2l.2-.2-.3-.2c-.1,0-.2-.1-.1-.2h0l1.6.2c-.2.4-.2.9.6,1.2s0,0,1-.6h0a8,8,0,0,1,2.1,1.5l-.4.3c-.5.3.1.5.1.5h1Z",
    transform: "translate(0 -18.9)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M423.5,201.1v.2c-.1.2-.4.1-.6.2s-.3.9-.7,1.1h-.7c-.2,0-.3.2-.4.3a1.1,1.1,0,0,1-.8.3,7.5,7.5,0,0,1,1.8-4.3h.2l.3.3a.7.7,0,0,1-.1.5l.4-.2c.1.1.2.3,0,.4l-.4.2c-.2.1-.4.1-.4.3a.5.5,0,0,0,.2.4.6.6,0,0,1,.1.4l.7-.4h.1Z",
    transform: "translate(0 -18.9)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M424,200.1h.6a.4.4,0,0,0,.1-.3c0-.1.1-.3,0-.4a.5.5,0,0,0-.2-.4c-.1-.1-.3,0-.4.1s0,.3-.1.4-.2.2-.2.3S423.8,200,424,200.1Z",
    transform: "translate(0 -18.9)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M427.5,196.7c-.3.2-.7-.1-1,0s-.2.3-.4.4h-.3s-.2.1-.1.2h0l.3.2h.1c0,.1-.1.3-.2.3h-.5v-.2h.1c.1,0,.1-.1.1-.2l-.2-.2c-.1,0-.1,0-.1.1l-.5.2c-.2.1-.4.3-.6.2H424v-.2a8.5,8.5,0,0,1,2.6-1.1l1-.2h0A.5.5,0,0,1,427.5,196.7Z",
    transform: "translate(0 -18.9)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M425.8,198.8c-.1-.1-.2,0-.2.1v.2h0c0,.1.1.2.2.1s0-.2,0-.3Z",
    transform: "translate(0 -18.9)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M429.4,201.1h-.5c-.2.1-.5,0-.5-.2s.2-.3.4-.3a.5.5,0,0,0-.5-.5.5.5,0,0,1,0,.5c0,.1,0,.2-.2.3a.2.2,0,0,1-.2-.2c-.3-.1.1-.6-.2-.8h-.4a1.3,1.3,0,0,0-1.2.8h-.5a.8.8,0,0,0-.2.5v.4c0,.1-.1.1-.1.2s.2.5.3.5h.6a.4.4,0,0,1,.1.5h-.1a.6.6,0,0,1-.2.7.8.8,0,0,1,.7.2c0,.1,0,.1.1.1h.1c.2-.2.4-.3.4-.6h.2c.1-.1,0-.3-.1-.2h0c-.2.1-.3,0-.3-.2a.4.4,0,0,1,.1-.3c.1-.1.1-.2.2-.2a.8.8,0,0,1,.4-.4c.3,0,.5.3.7.6s.1.3-.1.3h-.1c-.1,0-.1.2-.1.2h-.2c-.1,0-.1.2,0,.4l.2-.2c.1-.1.4.1.5,0l.3-.2c.2-.2.5-.2.5-.5s-.1-.3-.1-.4S429.6,201.3,429.4,201.1Z",
    transform: "translate(0 -18.9)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M423.5,203.1h.3c.1,0,.5.1.3.3s-.4-.2-.6-.1.1.2.1.3-.2.3-.1.4h1.2v-.3h.2c.1-.1.2-.2.3-.1s0-.2,0-.3l-.2-.2c-.1-.1-.1-.3,0-.3h.3c.1,0,.1-.1.1-.2v-.2h-.2c0,.1,0,.2-.1.2h-.2c0-.3-.1-.5-.1-.7h-.9c-.1,0-.2.2-.2.3s-.1.2-.2.4S423.3,202.9,423.5,203.1Z",
    transform: "translate(0 -18.9)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M423.7,206.5h-.6c-.2,0-.2-.2-.3-.1v.2l.2.3a.9.9,0,0,1,0,.7,1.4,1.4,0,0,1-1.1-.2h-.1c-.1-.2.1-.4.1-.6s-.4-.2-.3-.4h.3a.2.2,0,0,0,.1-.3h0a.6.6,0,0,0-.7.2c-.2,0-.2-.2-.2-.4s-.1-.4-.3-.3h-.1a1.3,1.3,0,0,0,.4,1l.2.3a.2.2,0,0,1-.2.2h0a.8.8,0,0,1,.4.4h0l-.3.4a11.8,11.8,0,0,1-.7-2,12.3,12.3,0,0,1-.2-1.9l.2-.2h.4c.2,0,.3-.3.6-.5s.4,0,.5.2a.7.7,0,0,1,.2.6.9.9,0,0,0-.1.5c.1.3.5.3.8.3a.4.4,0,0,0,.2.5c.2,0,.4-.1.4-.3s.4.1.4.3a.5.5,0,0,1-.2.4.2.2,0,0,0-.1.3h0c.1.1.4,0,.4.2S423.8,206.5,423.7,206.5Z",
    transform: "translate(0 -18.9)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M430.2,212.3H430a.5.5,0,0,1,0-.5c.1-.1.3-.2.4-.4l.2-.4.9-.2c.4,0,0-.3.1-.4h.9l.2-.2h.1l.9.2a.4.4,0,0,0-.4-.4c-.2,0-.5,0-.6-.2a.8.8,0,0,1-1.1.4h-.1c-.1-.1.2-.3.1-.4l-.4-.2H431v-.3a2.3,2.3,0,0,0-.1-.7c-.1-.3,0-.5.3-.5h.1c.1,0,.1-.2.1-.3l.6-.5.2-.2a1.1,1.1,0,0,0,.3-.8c-.2.1-.3.3-.5.5a.5.5,0,0,1-.6.2.4.4,0,0,1-.1.5h-.3a.5.5,0,0,1-.7-.3.4.4,0,0,1,.1-.3h.2a.9.9,0,0,0,.7-.3,1.2,1.2,0,0,1-.8-.4c-.1-.3-.1-.7.2-.8h-.2a1.2,1.2,0,0,1,.5-.5h.4c.1,0,.2-.1.2-.3s-.2-.2-.2-.4a.3.3,0,0,1,.3-.3h-.2l.2-.3h.3a.9.9,0,0,1,.7.3,1.3,1.3,0,0,1,.1.6v.7a1.1,1.1,0,0,0,.2.8h.5a2.5,2.5,0,0,0,1.2-.2,1,1,0,0,0,.5-.4,1.3,1.3,0,0,0,.1-.6c0-.4,0-1.1-.4-1.4h-.4l-.2.2H434l-.2.2c0,.1-.1.2-.2.1a.4.4,0,0,1-.1-.3c0-.1-.1-.4-.1-.6s.3-.4.4-.5l.3-.5c.2-.1.3,0,.4.1s.3.2.4.1,0,.4.1.5h.1v.2c0,.2,0,.4.2.5h.2a.8.8,0,0,0-.2-.7c0-.1-.1-.1-.1-.2h.1v-.2h.9a1.9,1.9,0,0,0,.2.7A8.3,8.3,0,0,1,430.2,212.3Z",
    transform: "translate(0 -18.9)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M429,209.7c-.1.1,0,.3,0,.5h-.6a.9.9,0,0,0,.3,1.1h-.4l-.4-.3-1-.8c-.1.1,0,.3.1.4s.4.1.5.3-.1.4.1.6h.2c.2.1.2.3.2.5h0a7.5,7.5,0,0,1-3.6-1h0v-.2a1.8,1.8,0,0,1,.5-.7c.3-.2.5-.4.5-.7s-.6.6-.9.8h-.3l-.4.3a8,8,0,0,1-2.1-2,2.4,2.4,0,0,0,.2-.8c.1-.1.2.1.4.1s.2-.2.4-.2.2.4.4.5.3-.1.4-.1h.6c.2-.1.1-.7.2-1.1l.4-.3a.5.5,0,0,0,.3-.5c0-.3-.1-.5-.1-.7a.6.6,0,0,1,0-.6c.3-.3.7-.1.9-.3s.3-.4.6-.5l.6-.2h.2a.4.4,0,0,1,.1.3,3,3,0,0,1-.4,1c.3.2.7.3.8,0h.5l.3.6a1.3,1.3,0,0,0-1.2.8v.2H427c-.4,0-.6-.2-1-.3s-.7-.1-.8.3.5.1.7.2h.5l1.1.3a.7.7,0,0,0,.4-.6,1.6,1.6,0,0,0,1.1.5c-.1.4-.2.7,0,1a1.3,1.3,0,0,1,.3.8.5.5,0,0,0-.6.2A.6.6,0,0,0,429,209.7Z",
    transform: "translate(0 -18.9)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M308.3,37.7a8.8,8.8,0,1,1-6.7,10.5,8.7,8.7,0,0,1,6.5-10.5Z",
    transform: "translate(0 -18.9)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M316.7,43.7a.9.9,0,1,0-.9-.9h0A.9.9,0,0,0,316.7,43.7Z",
    transform: "translate(0 -18.9)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M313.7,39.3a.9.9,0,0,0,1.8,0h0l-1.2-.7A1.1,1.1,0,0,0,313.7,39.3Z",
    transform: "translate(0 -18.9)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M304,47.7a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,304,47.7Z",
    transform: "translate(0 -18.9)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M318.6,43.6a6.9,6.9,0,0,0-.5-1.3v.2A1.6,1.6,0,0,0,318.6,43.6Z",
    transform: "translate(0 -18.9)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M303.4,43.5a1.3,1.3,0,0,0-1-1.3,11.4,11.4,0,0,0-.9,2.6h.5A1.5,1.5,0,0,0,303.4,43.5Z",
    transform: "translate(0 -18.9)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M317.6,47.4a1.4,1.4,0,0,0,1.1,1.3A12.4,12.4,0,0,0,319,46,1.4,1.4,0,0,0,317.6,47.4Z",
    transform: "translate(0 -18.9)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M309,41.6a1.4,1.4,0,1,0-1.4,1.4A1.4,1.4,0,0,0,309,41.6Z",
    transform: "translate(0 -18.9)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 313.6,
    cy: 30.9,
    r: 0.9
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M317,50.2a1,1,0,0,0,.6.9l.8-1.6-.5-.2A.9.9,0,0,0,317,50.2Z",
    transform: "translate(0 -18.9)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M314.6,53.6c0,.1,0,.1.1.2a7.5,7.5,0,0,0,2.5-2.2h-.5A2.2,2.2,0,0,0,314.6,53.6Z",
    transform: "translate(0 -18.9)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M302.3,46.9a2.1,2.1,0,0,0-.8-1.7,7.6,7.6,0,0,0,.1,3v.2A1.8,1.8,0,0,0,302.3,46.9Z",
    transform: "translate(0 -18.9)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M306.5,38.4h0a9.3,9.3,0,0,0-3.7,3.1h.6a3.1,3.1,0,0,0,3.1-3.1Z",
    transform: "translate(0 -18.9)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M310.7,38.8a2,2,0,0,0,1.8-1.1,9.2,9.2,0,0,0-3.7-.1A2,2,0,0,0,310.7,38.8Z",
    transform: "translate(0 -18.9)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M310.2,52.7a.9.9,0,1,0,.9.9h0A.9.9,0,0,0,310.2,52.7Z",
    transform: "translate(0 -18.9)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M308.3,54.3a.8.8,0,0,0-.7.4l1.5.3A.8.8,0,0,0,308.3,54.3Z",
    transform: "translate(0 -18.9)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M304.7,52.2a.9.9,0,0,0-.7.3l1.4,1.1a.8.8,0,0,0,.2-.5A.9.9,0,0,0,304.7,52.2Z",
    transform: "translate(0 -18.9)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M315.1,44.7l.2-.2-.2-.2c-.2,0-.3.1-.3.2S314.9,44.7,315.1,44.7Z",
    transform: "translate(0 -18.9)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M316.3,41.3a.2.2,0,0,0,.2-.2h0l-.2-.2a.2.2,0,0,0,0,.4Z",
    transform: "translate(0 -18.9)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M317.9,44.7a.2.2,0,0,0,0-.4c-.2,0-.3.1-.3.2S317.7,44.7,317.9,44.7Z",
    transform: "translate(0 -18.9)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M310.6,39.5a.2.2,0,0,0,.2-.2h0l-.2-.2-.2.2a.2.2,0,0,0,.2.2Z",
    transform: "translate(0 -18.9)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M308,43.3a.2.2,0,1,0,0,.4c.2,0,.3-.1.3-.2S308.2,43.3,308,43.3Z",
    transform: "translate(0 -18.9)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M306.6,49.1l-.2-.2-.2.2a.2.2,0,0,0,.4,0Z",
    transform: "translate(0 -18.9)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M303.2,46.7l.2.2.2-.2a.2.2,0,0,0-.4,0Z",
    transform: "translate(0 -18.9)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M312.2,47.7l.2.2c.2,0,.3-.1.3-.2s-.1-.2-.3-.2a.2.2,0,0,0-.2.2Z",
    transform: "translate(0 -18.9)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 312.2,
    cy: 26.3,
    r: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M314.1,51.5a.2.2,0,0,0-.2.2h0c0,.2.1.2.2.2s.2,0,.2-.2a.2.2,0,0,0-.2-.2Z",
    transform: "translate(0 -18.9)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M304.9,42.1l.2-.2a.2.2,0,0,0-.4,0Z",
    transform: "translate(0 -18.9)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M309.3,41.8a.2.2,0,0,0,.2-.2h0l-.2-.2a.2.2,0,0,0,0,.4Z",
    transform: "translate(0 -18.9)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M309.1,52.2a.2.2,0,0,0-.2.2h0l.2.2.2-.2a.2.2,0,0,0-.2-.2Z",
    transform: "translate(0 -18.9)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M308.6,49.7a.2.2,0,0,0-.2.2h0c0,.2.1.2.2.2s.2,0,.2-.2a.2.2,0,0,0-.2-.2Z",
    transform: "translate(0 -18.9)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M303.6,50.9l-.2.2a.2.2,0,1,0,.4,0Z",
    transform: "translate(0 -18.9)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M311.6,54.3a.2.2,0,1,0,0,.4h0l.2-.2Z",
    transform: "translate(0 -18.9)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M312.7,42.1a.5.5,0,1,0-.5-.5A.5.5,0,0,0,312.7,42.1Z",
    transform: "translate(0 -18.9)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M312.7,39.8a.5.5,0,1,0-.5-.5A.5.5,0,0,0,312.7,39.8Z",
    transform: "translate(0 -18.9)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M307.6,39.8c.2,0,.4-.3.4-.5s-.2-.5-.4-.5a.5.5,0,0,0,0,1Z",
    transform: "translate(0 -18.9)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M311.6,52.2a.5.5,0,1,0-.5.5A.5.5,0,0,0,311.6,52.2Z",
    transform: "translate(0 -18.9)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M306.6,52.6a.5.5,0,1,0,.5.5A.5.5,0,0,0,306.6,52.6Z",
    transform: "translate(0 -18.9)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 304.9,
    cy: 32.5,
    r: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M312.7,53.1a.5.5,0,1,0,.5.5A.5.5,0,0,0,312.7,53.1Z",
    transform: "translate(0 -18.9)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M309.5,47.2a.5.5,0,1,0-.5-.5A.5.5,0,0,0,309.5,47.2Z",
    transform: "translate(0 -18.9)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M316.3,48.7a.5.5,0,1,0-.5-.5A.5.5,0,0,0,316.3,48.7Z",
    transform: "translate(0 -18.9)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M305.4,46a.5.5,0,0,0-.5.5c0,.2.3.4.5.4a.4.4,0,0,0,.4-.4C305.8,46.3,305.6,46,305.4,46Z",
    transform: "translate(0 -18.9)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 303.4,
    cy: 26.5,
    r: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M134.9,314.9a51.4,51.4,0,0,1,5.3-11.1,30,30,0,0,1,3.2-4.7,47.8,47.8,0,0,1,5.2-5.8,37.5,37.5,0,0,1,5.3-4.4h0l2.3-1.6a55.4,55.4,0,0,1,5.3-3,22.1,22.1,0,0,1,3.5-1.6,32.4,32.4,0,0,1,5.2-1.9,46.5,46.5,0,0,1,7.2-1.6h.1a46.4,46.4,0,0,1,9.1-.6,51.8,51.8,0,0,1,25.7,7.4h0a40.9,40.9,0,0,1,6.4,4.5,31.1,31.1,0,0,1,2.8,2.3l2.7,2.7c.6.6,1.1,1.3,1.7,2a13.9,13.9,0,0,1,2.1,2.7,50.4,50.4,0,0,1,4,6.2l.9,1.8a40.2,40.2,0,0,1,2.6,6,25.8,25.8,0,0,1,.8,2.6,60.6,60.6,0,0,1,2.1,11.9c0,1.4.1,2.9,0,4.3a16.2,16.2,0,0,1-.1,2.2l-.3,3.4c-.3,2.3-.8,4.5-1.3,6.7a27.1,27.1,0,0,1-1.4,4.3,29.6,29.6,0,0,1-2,4.9,64.8,64.8,0,0,1-8.5,12.8,52.2,52.2,0,0,1-4.8,4.6,57,57,0,0,1-5.5,4.2,56.3,56.3,0,0,1-7.6,4.2,63.7,63.7,0,0,1-6.1,2.3h0a47,47,0,0,1-5.1,1.2h0a57.8,57.8,0,0,1-11.7,1,52.4,52.4,0,0,1-19.9-4.4h0l-4.1-2-2.8-1.6-3.3-2.2-1.6-1.3a49.8,49.8,0,0,1-5.4-4.9,51.9,51.9,0,0,1-12.3-21,52.4,52.4,0,0,1-2.3-11.8c-.1-1.7-.1-3.5-.1-5.2a25.9,25.9,0,0,1,.4-4.8A43.5,43.5,0,0,1,134.9,314.9Z",
    transform: "translate(0 -18.9)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M134.9,314.9a51.4,51.4,0,0,1,5.3-11.1,30,30,0,0,1,3.2-4.7,47.8,47.8,0,0,1,5.2-5.8,37.5,37.5,0,0,1,5.3-4.4h0l2.3-1.6a55.4,55.4,0,0,1,5.3-3,22.1,22.1,0,0,1,3.5-1.6,32.4,32.4,0,0,1,5.2-1.9,46.5,46.5,0,0,1,7.2-1.6h.1a46.4,46.4,0,0,1,9.1-.6,51.8,51.8,0,0,1,25.7,7.4h0a40.9,40.9,0,0,1,6.4,4.5,31.1,31.1,0,0,1,2.8,2.3l2.7,2.7c.6.6,1.1,1.3,1.7,2a13.9,13.9,0,0,1,2.1,2.7,50.4,50.4,0,0,1,4,6.2l.9,1.8a40.2,40.2,0,0,1,2.6,6,25.8,25.8,0,0,1,.8,2.6,60.6,60.6,0,0,1,2.1,11.9c0,1.4.1,2.9,0,4.3a16.2,16.2,0,0,1-.1,2.2l-.3,3.4c-.3,2.3-.8,4.5-1.3,6.7a27.1,27.1,0,0,1-1.4,4.3,29.6,29.6,0,0,1-2,4.9,64.8,64.8,0,0,1-8.5,12.8,52.2,52.2,0,0,1-4.8,4.6,57,57,0,0,1-5.5,4.2,56.3,56.3,0,0,1-7.6,4.2,63.7,63.7,0,0,1-6.1,2.3h0a47,47,0,0,1-5.1,1.2h0a57.8,57.8,0,0,1-11.7,1,52.4,52.4,0,0,1-19.9-4.4h0l-4.1-2-2.8-1.6-3.3-2.2-1.6-1.3a49.8,49.8,0,0,1-5.4-4.9,51.9,51.9,0,0,1-12.3-21,52.4,52.4,0,0,1-2.3-11.8c-.1-1.7-.1-3.5-.1-5.2a25.9,25.9,0,0,1,.4-4.8A43.5,43.5,0,0,1,134.9,314.9Z",
    transform: "translate(0 -18.9)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M134.9,314.9a40.2,40.2,0,0,1,5,.6c2.3.5,4.6,1.4,7,1.8s6.1.4,9.1.7,6.2,1.3,8.2,3.6a182.3,182.3,0,0,0-22.1,2.5c-3.2.6-6.4,1.2-9.5,1.5A43.5,43.5,0,0,1,134.9,314.9Z",
    transform: "translate(0 -18.9)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M218.5,335.7a104,104,0,0,1,13.7-1,41.8,41.8,0,0,1,6.1.5l-.3,3.4h-.5A49.1,49.1,0,0,1,218.5,335.7Z",
    transform: "translate(0 -18.9)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M193.3,318.9a5.7,5.7,0,0,1,2.6-.1,59.1,59.1,0,0,0,10.3-.2l8.9-.9a31.1,31.1,0,0,0,6.8-1.1,22.6,22.6,0,0,1,3.7-1.1,12.3,12.3,0,0,1,4.7.3l6,1a60.6,60.6,0,0,1,2.1,11.9,18.4,18.4,0,0,1-4.1-.5c-2.3-.5-4.5-1.5-6.8-1.7s-4.2.1-6.3,0a38.5,38.5,0,0,1-6.6-1.3c-7.4-1.7-15.3-1.7-22.5-4.3A1.6,1.6,0,0,1,193.3,318.9Z",
    transform: "translate(0 -18.9)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M153.9,288.9l2.3-1.6a55.4,55.4,0,0,1,5.3-3,22.1,22.1,0,0,1,3.5-1.6h.7a248.5,248.5,0,0,0,36.2,6.9c6.5.7,13.3,1.3,19.6,3.1l2.7,2.7a117.2,117.2,0,0,0-20.4-3.3c-5.9-.4-11.8-.1-17.6-.7s-10.5-1.7-15.8-1.4l-3.5.3a46.1,46.1,0,0,1-11.7-1.2Z",
    transform: "translate(0 -18.9)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.3,297.1c5.2-1.1,10.6-.6,15.9-.1a124.6,124.6,0,0,0,18.3.8c1.8-.1,3.6-.3,5.4-.3a13.9,13.9,0,0,1,2.1,2.7,50.4,50.4,0,0,1,4,6.2l.9,1.8-1.5-.2c-3.2-.3-6.3-.5-9.4-1a56.3,56.3,0,0,1-6.9-1.4,35.8,35.8,0,0,1-5.5-1.9l-4.3-2a47.2,47.2,0,0,0-5.3-1.8C195.5,298.6,190.9,297.2,186.3,297.1Z",
    transform: "translate(0 -18.9)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M214.2,302c2.4-.5,4.9,0,7.2-.5a13.4,13.4,0,0,0,2.7-.7,26.3,26.3,0,0,1,3.9-.6,50.4,50.4,0,0,1,4,6.2,86.7,86.7,0,0,1-8.9-1.3l-4.9-1c-.9-.2-4.2-.5-4.7-1.1S213.8,302.1,214.2,302Z",
    transform: "translate(0 -18.9)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M143.4,299.1a47.8,47.8,0,0,1,5.2-5.8,51.2,51.2,0,0,1,7.8,1.5,32.4,32.4,0,0,0,6.2,1.2c2.8.2,5.6-.4,8.3-.5s5.8.5,7.7,2.5l-10.7.6c-6.2.4-12.5.7-18.7.6Z",
    transform: "translate(0 -18.9)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M157.8,287.7l-1.6-.4a55.4,55.4,0,0,1,5.3-3,70.4,70.4,0,0,0,8,1.4c4.4.5,9.3.5,12.9,3.1l-5.8-.6c-3.8-.4-7.8-.9-11.6-.4a21.2,21.2,0,0,1-4.4.4A13.7,13.7,0,0,1,157.8,287.7Z",
    transform: "translate(0 -18.9)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M170.2,280.8a46.5,46.5,0,0,1,7.2-1.6h.1a46.4,46.4,0,0,1,9.1-.6,51.8,51.8,0,0,1,25.7,7.4h0a40.9,40.9,0,0,1,6.4,4.5c-3.5,0-8.2-1.4-9.7-1.7l-12.1-2.1C187.9,285,179,283,170.2,280.8Z",
    transform: "translate(0 -18.9)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M177.5,279.2a46.4,46.4,0,0,1,9.1-.6,51.8,51.8,0,0,1,25.7,7.4,8.3,8.3,0,0,0-2.2-.3l-2,.3a12.2,12.2,0,0,1-2.7,0,56.2,56.2,0,0,1-10-1.5,89.3,89.3,0,0,1-8.7-3A59,59,0,0,0,177.5,279.2Z",
    transform: "translate(0 -18.9)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M152.3,343.8a2.5,2.5,0,0,1,2-.9c2.9-.8,5.4-2.7,8.1-4,4.4-2,9.4-2.1,14.2-2.3a73,73,0,0,1,8.1.1c2.4.3,4.7.8,7,1.3,5,1.2,9.9,2.6,14.8,4,9,2.6,18,5.4,27.3,7.2l1.5.4a29.6,29.6,0,0,1-2,4.9c-3,.2-6.3-.4-9-.5-8.2-.3-16.3,1.8-24.2,4.2a33.8,33.8,0,0,1-7,1.6,31.2,31.2,0,0,1-9.5-1.7l-10.8-3.2a52,52,0,0,1-5.5-2.1c-1.5-.8-2.9-1.8-4.3-2.7a29.6,29.6,0,0,0-7.6-3.1,5,5,0,0,1-2.4-.9A1.9,1.9,0,0,1,152.3,343.8Z",
    transform: "translate(0 -18.9)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M201.1,353.5a33.8,33.8,0,0,1-10,.7,61,61,0,0,1-12.8-1.2,61.2,61.2,0,0,1-9.3-3.5c-1.8-.8-3.8-1.6-4.8-3.3,9.9-6.1,22.5-5.1,33.9-2.4,6.9,1.6,13.7,3.9,20.5,6.1-.6-.2-3.7,1.4-4.5,1.6a7.7,7.7,0,0,1-3.7,0C207,351.3,204.2,352.7,201.1,353.5Z",
    transform: "translate(0 -18.9)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M134.6,347.4l3.6.5c2.1.4,4.5,1.7,4.4,3.8,5,0,10.4,0,14.5,2.8l-5.8,1.4,49.8,7.9a16,16,0,0,0,4.4.4c3.2-.3,5.9-2.3,8.9-3s9.6-.1,13.9,1.6a53.7,53.7,0,0,1-3.5,4.5,52.2,52.2,0,0,1-4.8,4.6,57,57,0,0,1-5.5,4.2c-10.7-.9-21.2-3.8-31.5-6.8l11.5-1c2.1-.2,4.4-.4,6-1.8-6.2-1.1-12.5-2-18.8-2.5-3.6-.4-7.2-.6-10.8-.8L152.3,362a2.5,2.5,0,0,0-1.7.2,1.2,1.2,0,0,0-.5,1.5,1.3,1.3,0,0,0,1,.4l5.8,1.3c1.8.4,4,1.6,3.5,3.3l-9.9-.2h-3.6A52.9,52.9,0,0,1,134.6,347.4Z",
    transform: "translate(0 -18.9)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M152.3,373.3a47.2,47.2,0,0,1,8.4-.3c6.2.4,12.3,1.9,18.5,3.1a19.9,19.9,0,0,0,4.9.6c1.9-.1,3.8-.6,5.6-.6s5.8,1.2,8.5,2.2,5.6,1,8.7,2a63.7,63.7,0,0,1-6.1,2.3h-.2a48.1,48.1,0,0,0-11.8-2.7c-8.7-1.2-17.5-2.4-26.3-1.8l-2.5.4-2.8-1.6-3.3-2.2Z",
    transform: "translate(0 -18.9)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M209.2,369.1c4.7-2.5,10.2-2.4,15.6-1.8a52.2,52.2,0,0,1-4.8,4.6A45.2,45.2,0,0,1,209.2,369.1Z",
    transform: "translate(0 -18.9)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M164.1,380.4c7.8-1.4,15.8-.4,23.5,1.4,1.1.3,5.2,1,8.1,2a57.8,57.8,0,0,1-11.7,1A52.4,52.4,0,0,1,164.1,380.4Z",
    transform: "translate(0 -18.9)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M153.9,374.6l1.6-.2c3.7-.3,7.5-.6,11.1.3-2.6-.6-6,.8-9.4,2.1Z",
    transform: "translate(0 -18.9)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M132.6,325.6a25.9,25.9,0,0,0-.4,4.8c0,1.7,0,3.5.1,5.2a24.1,24.1,0,0,0,3.8.1l17.8-1.3c-1.9-2.1-5.1-2.2-7.9-1.9s-5.8.8-8.3-.4a23.1,23.1,0,0,1,14.2-4.2c3.5.1,7,1,10.4.7s6-1.6,9-1.2a16,16,0,0,1,4.3,1.1c15.2,4.3,32.2-4.1,46.9,1.6l-27.3,3.1c3.8,3.4,9.5,3.2,14.6,3.9a37.6,37.6,0,0,1,15.9,5.7c1.7,1,3.3,2.3,5.3,2.7a17,17,0,0,0,4.5,0l1.2-.2c.5-2.2,1-4.4,1.3-6.7l.3-3.4a16.2,16.2,0,0,0,.1-2.2c.1-1.4,0-2.9,0-4.3a60.6,60.6,0,0,0-2.1-11.9,25.8,25.8,0,0,0-.8-2.6c-3.7.1-7.4.5-11-.2l-4.5-1a42.1,42.1,0,0,0-5-.4l-34.2-.7c-4.7-.1-9.4-.3-14.1-.8a105.1,105.1,0,0,1,32.1-2.9c1.7.1,3.4.2,4.9-.7-5.1-3.7-12.2-2.3-18.5-3-2.8-.3-5.6-1-8.5-1s-5.2.8-7.8,1.1a60.3,60.3,0,0,1-8.5.1l-20.2-.9a51.4,51.4,0,0,0-5.3,11.1A43.5,43.5,0,0,0,132.6,325.6ZM158,308.2a23.7,23.7,0,0,1,6.5-.9l.8.8a18.7,18.7,0,0,1-11.2,1Z",
    transform: "translate(0 -18.9)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M345.5,334.6c-16.7,7.7-28.2,18.6-25.6,24.2s18.3,3.9,35-3.8,28.3-18.6,25.7-24.2S362.3,326.9,345.5,334.6Zm8.3,17.9c-14.7,6.8-28.3,8.5-30.4,3.9s8-13.8,22.7-20.5,28.3-8.5,30.4-4S368.4,345.8,353.8,352.5Z",
    transform: "translate(0 -18.9)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M345.5,334.6c-16.7,7.7-28.2,18.6-25.6,24.2s18.3,3.9,35-3.8,28.3-18.6,25.7-24.2S362.3,326.9,345.5,334.6Zm8.3,17.9c-14.7,6.8-28.3,8.5-30.4,3.9s8-13.8,22.7-20.5,28.3-8.5,30.4-4S368.4,345.8,353.8,352.5Z",
    transform: "translate(0 -18.9)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M345.9,335.5c-13.5,6.2-22.8,14.8-20.8,19.2s14.6,2.8,28.1-3.4,22.9-14.8,20.9-19.2S359.4,329.2,345.9,335.5Zm6.4,13.9c-11.8,5.4-22.7,7-24.4,3.4s6.6-10.9,18.5-16.3,22.7-7,24.4-3.5S364.2,343.9,352.3,349.4Z",
    transform: "translate(0 -18.9)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M345.9,335.5c-13.5,6.2-22.8,14.8-20.8,19.2s14.6,2.8,28.1-3.4,22.9-14.8,20.9-19.2S359.4,329.2,345.9,335.5Zm6.4,13.9c-11.8,5.4-22.7,7-24.4,3.4s6.6-10.9,18.5-16.3,22.7-7,24.4-3.5S364.2,343.9,352.3,349.4Z",
    transform: "translate(0 -18.9)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M346.3,336.3c-10.6,4.9-17.9,11.7-16.3,15.1s11.4,2.3,22.1-2.6,17.9-11.7,16.3-15.1S356.9,331.4,346.3,336.3Zm5.1,11c-9.3,4.2-17.9,5.4-19.2,2.6s5.2-8.5,14.5-12.8,17.8-5.5,19.1-2.7S360.6,343,351.4,347.3Z",
    transform: "translate(0 -18.9)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M346.3,336.3c-10.6,4.9-17.9,11.7-16.3,15.1s11.4,2.3,22.1-2.6,17.9-11.7,16.3-15.1S356.9,331.4,346.3,336.3Zm5.1,11c-9.3,4.2-17.9,5.4-19.2,2.6s5.2-8.5,14.5-12.8,17.8-5.5,19.1-2.7S360.6,343,351.4,347.3Z",
    transform: "translate(0 -18.9)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 350.3,
    cy: 326.1,
    r: 16
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M338.6,333.8h0a15.8,15.8,0,0,1,13.1-4.9l1.1.2a15.9,15.9,0,0,1,9.5,5.3l.8.9a20.2,20.2,0,0,1,1.8,3.2,6.4,6.4,0,0,1,.6,1.8,13.7,13.7,0,0,1,.6,5.7v.3a5.9,5.9,0,0,1-.2,1.3,12,12,0,0,1-1.5,4.5,10.9,10.9,0,0,1-.8,1.5,16.1,16.1,0,0,1-14.8,7.1,17.6,17.6,0,0,1-5-1.3h-.1l-.4-.2a13.8,13.8,0,0,1-4-2.8h-.2a18.3,18.3,0,0,1-3.1-4.2,5.4,5.4,0,0,0-.5-1.1c-.1-.4-.3-.7-.4-1.1l-.5-1.7a20.2,20.2,0,0,1-.3-4.9A16.3,16.3,0,0,1,338.6,333.8Z",
    transform: "translate(0 -18.9)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M363.4,353.8a15.8,15.8,0,0,1-14.6,6.9,18.2,18.2,0,0,1-4.6-1.1C349.3,359.2,356.8,358.4,363.4,353.8Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M350.5,341.7c3.4-1.3,10.3-2.9,13.4-5.1a1.6,1.6,0,0,1,.4.7,25.6,25.6,0,0,0-4.8,3.9c-3.4,3.2-5.2,6.1-10.8,6.3S346.7,343.1,350.5,341.7Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M340.5,357.5c5-.7,17.1-2.8,25.3-9.3-.1.5-.3,1.1-.4,1.7-5.3,2.6-15.1,7.8-23.3,8.6Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M336.7,353.3a81.9,81.9,0,0,0,9.6-2c6.4-1.9,15.4-6.5,19.5-10a13.3,13.3,0,0,1,.3,2.8c-5.1,3.4-17.5,10.9-27.8,11.2A15.6,15.6,0,0,1,336.7,353.3Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M336.5,336.7a4.1,4.1,0,0,1,.7-1.1c4.8-1.5,14.1-3.7,18.3-5.8a6.4,6.4,0,0,1,1.9.8C352.1,331.8,341.2,335.6,336.5,336.7Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M335.2,339.3a49.1,49.1,0,0,1,11.3-2.2c2.6-.1,10.2-3,12.9-5.3l.6.4c-6.6,2.8-14.6,9.7-18.4,11.7a38.2,38.2,0,0,1-7.2,3.1,15.3,15.3,0,0,1-.1-3.7A13.7,13.7,0,0,1,335.2,339.3Z",
    transform: "translate(0 -18.9)"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M334.6,348.2l3.5-1c4.3-1.5,12.2-7.9,19.2-10.8l5-2,.8.9a46,46,0,0,1-6.3,3.1,55.9,55.9,0,0,0-11.9,6.7c-2,1.7-7.3,4-9.8,4.8C334.9,349.4,334.8,348.8,334.6,348.2Z",
    transform: "translate(0 -18.9)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M335.5,351c4-1,8.1-1.7,12.2-2.3,7-.8,9.6-3.9,12.4-6.8a18.2,18.2,0,0,1,4.8-3.4,6.4,6.4,0,0,1,.6,1.8,45.1,45.1,0,0,1-10.4,6.7c-6.6,3.1-15.7,4.6-19.1,5.1A5.4,5.4,0,0,0,335.5,351Z",
    transform: "translate(0 -18.9)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M339.1,356.3a58.6,58.6,0,0,0,17.3-5.2c4.5-2.2,7.6-3.9,9.7-5.1v.3a5.9,5.9,0,0,1-.2,1.3c-5,2.7-16.5,8.2-26.6,8.8Z",
    transform: "translate(0 -18.9)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M338.6,333.8a15.8,15.8,0,0,1,13.1-4.9l1.1.2C349.4,330.6,343.1,333.2,338.6,333.8Z",
    transform: "translate(0 -18.9)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M343.3,359.2c4-1,14.3-3.5,18.6-5.9l2.5-1.2a10.9,10.9,0,0,1-.8,1.5c-3.2,1.3-9.2,3.8-12.6,4.4a61,61,0,0,0-7.2,1.4h-.1Z",
    transform: "translate(0 -18.9)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M356.8,331.8s-5.8,3.6-8.4,4.1a40.5,40.5,0,0,1-4.9.4S352,332,356.8,331.8Z",
    transform: "translate(0 -18.9)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M374.4,330.1a3.7,3.7,0,0,1,2.1,1.8c2.1,4.6-8.1,13.9-22.7,20.6s-28.3,8.5-30.4,3.9a3.4,3.4,0,0,1,0-2.8l-3.6,1.7a4.7,4.7,0,0,0,.1,3.5c2.6,5.6,18.3,3.9,35-3.8s28.3-18.6,25.7-24.2a4.9,4.9,0,0,0-2.6-2.3Z",
    transform: "translate(0 -18.9)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M374.4,330.1a3.7,3.7,0,0,1,2.1,1.8c2.1,4.6-8.1,13.9-22.7,20.6s-28.3,8.5-30.4,3.9a3.4,3.4,0,0,1,0-2.8l-3.6,1.7a4.7,4.7,0,0,0,.1,3.5c2.6,5.6,18.3,3.9,35-3.8s28.3-18.6,25.7-24.2a4.9,4.9,0,0,0-2.6-2.3Z",
    transform: "translate(0 -18.9)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M370,332.1a3.4,3.4,0,0,1,.8.9c1.6,3.6-6.6,10.9-18.5,16.4s-22.7,7-24.4,3.4a5,5,0,0,1-.2-1.2l-2.9,1.4a2.5,2.5,0,0,0,.3,1.7c2,4.3,14.6,2.8,28.1-3.4s22.9-14.8,20.9-19.2a3.7,3.7,0,0,0-1.2-1.3Z",
    transform: "translate(0 -18.9)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M370,332.1a3.4,3.4,0,0,1,.8.9c1.6,3.6-6.6,10.9-18.5,16.4s-22.7,7-24.4,3.4a5,5,0,0,1-.2-1.2l-2.9,1.4a2.5,2.5,0,0,0,.3,1.7c2,4.3,14.6,2.8,28.1-3.4s22.9-14.8,20.9-19.2a3.7,3.7,0,0,0-1.2-1.3Z",
    transform: "translate(0 -18.9)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M365.6,334.1l.2.3c1.3,2.8-5.2,8.6-14.4,12.9s-17.9,5.4-19.2,2.6v-.3l-2.3,1.1a1.9,1.9,0,0,0,.2.7c1.5,3.4,11.4,2.3,22.1-2.6s17.9-11.7,16.3-15.1l-.4-.6Z",
    transform: "translate(0 -18.9)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M365.6,334.1l.2.3c1.3,2.8-5.2,8.6-14.4,12.9s-17.9,5.4-19.2,2.6v-.3l-2.3,1.1a1.9,1.9,0,0,0,.2.7c1.5,3.4,11.4,2.3,22.1-2.6s17.9-11.7,16.3-15.1l-.4-.6Z",
    transform: "translate(0 -18.9)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M57.1,193.5,53.4,195a6.9,6.9,0,0,0,1.1,5,5.5,5.5,0,0,0,4.1,2.1l2.6-4.9Z",
    transform: "translate(0 -18.9)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M61.2,197.2l-2.6,4.9a5.1,5.1,0,0,1-3.1-1.1l-1-1a6.9,6.9,0,0,1-1.1-5l3.7-1.5Z",
    transform: "translate(0 -18.9)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M61.2,197.2l-2.6,4.9a5.1,5.1,0,0,1-3.1-1.1Z",
    transform: "translate(0 -18.9)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M60.7,198.2,57.3,202s.8,3.2,3.9,3.3,4.2-1.3,4.2-1.3l.2-4.4Z",
    transform: "translate(0 -18.9)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M60.7,198.2,57.3,202s.8,3.2,3.9,3.3,4.2-1.3,4.2-1.3l.2-4.4Z",
    transform: "translate(0 -18.9)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M81.3,182.5c-4.4,4.4-10.2,20.9-9.9,23.1s-6.3,6.1-6.3,6.1L62.4,179s4.5-3.9,6.4-4.5,6,4,9.3,1.2S81.3,182.5,81.3,182.5Z",
    transform: "translate(0 -18.9)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M71.4,205.6c.1,1.2-1.9,3-3.6,4.3h0l-2.7,1.8L62.4,179s2.2-1.9,4.1-3.2a10.5,10.5,0,0,1,2.3-1.3c2-.5,6,4,9.3,1.2l.9-.5c1.2-.2,1.8,1.5,2.1,3.4h0c.2,1.9.2,3.9.2,3.9C76.9,186.9,71.1,203.4,71.4,205.6Z",
    transform: "translate(0 -18.9)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M71.4,205.6c.1,1.2-1.9,3-3.6,4.3,2.2-2.3,1.9-4.5,2.3-9.3s3.2-14,3.2-14a16.5,16.5,0,0,0-2.6-7.1c-1.6-2.4-3-3.5-4.2-3.7a10.5,10.5,0,0,1,2.3-1.3c2-.5,6,4,9.3,1.2l.9-.5,2.1,3.4h0c.2,1.9.2,3.9.2,3.9C76.9,186.9,71.1,203.4,71.4,205.6Z",
    transform: "translate(0 -18.9)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M57.1,193.5s23-24.7,26.2-26.6,5.3-1.2,5.3-1.2,4.3-1.1,5.6-.1.3,2.5-2.5,6.3c-5.2,7.2-27.2,28.8-27.2,28.8S57.2,199.3,57.1,193.5Z",
    transform: "translate(0 -18.9)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M92.8,170.3l-1.1,1.6c-5.2,7.2-27.2,28.8-27.2,28.8s-7.3-1.4-7.4-7.2c0,0,23-24.7,26.2-26.6a9.5,9.5,0,0,1,3.3-1.3,4.4,4.4,0,0,1,2,.1l.5-.2,1.3-.2c1.3-.2,3-.3,3.8.3S94.7,167.6,92.8,170.3Z",
    transform: "translate(0 -18.9)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M85.2,171.7l-.6-.4a.9.9,0,0,1-.1-1.3h0c.8-1,2.2-2.8,2.1-4.4a4.4,4.4,0,0,1,2,.1l.5-.2c.5,2.2-1.7,4.9-2.7,6.1A.9.9,0,0,1,85.2,171.7Z",
    transform: "translate(0 -18.9)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M92.8,170.3a6.8,6.8,0,0,1-2.4-5c1.3-.2,3-.3,3.8.3S94.7,167.6,92.8,170.3Z",
    transform: "translate(0 -18.9)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7,195.3V195a1.1,1.1,0,0,0,.9-.5.8.8,0,0,0,.2-.8c-.5-.5-1.5,1.1-2.2.3s-.4-.8.1-1.4l.9-.5v.4a1,1,0,0,0-.7.4c-.4.3-.4.6-.2.8s1.5-1.1,2.2-.3.4.8-.2,1.4A1.4,1.4,0,0,1,66.7,195.3Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,190.2c.5.4.4,1-.1,1.6l-.5.5.6.6-.3.3-2.1-2.1.8-.8C68.5,189.8,69.1,189.7,69.5,190.2Zm-.3.3c-.3-.3-.6-.3-1,.1l-.5.5.9.9.5-.5C69.5,191.1,69.5,190.8,69.2,190.5Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3,189l-1.1,1.1.3.8-.3.3-1.2-3,.3-.3,3.1,1.1-.3.3Zm-.3-.1-1.5-.6.6,1.5Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7,187.6a1.6,1.6,0,0,1,0-2.2,1.8,1.8,0,0,1,1.2-.5v.4a1.1,1.1,0,0,0-.8.3,1.4,1.4,0,0,0,0,1.7,1.2,1.2,0,0,0,1.6,0h0a.9.9,0,0,0,.4-.8h.3a1.2,1.2,0,0,1-.4,1.1,1.6,1.6,0,0,1-2.3.1Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6,184.2l.3.2-1.5,1.5-2.1-2,1.4-1.5.3.3-1.2,1.1.7.7,1-1.1.3.3-1.1,1,.7.7Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,181.7a1,1,0,0,1-.1,1.4h-.1a1.2,1.2,0,0,1-1,.5v-.4a1.1,1.1,0,0,0,.9-.4.7.7,0,0,0,.2-.8h-.1c-.3-.2-.6-.2-1,.3l-.5.5-1-1.2,1.2-1.2.2.3-.9.9.5.6.3-.2C78.4,181.4,78.9,181.4,79.3,181.7Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8,178.3l.2.2,1.1,2.7-.4.3-1-2.7-.9,1,.4.4-.3.3-.7-.7Z",
    transform: "translate(0 -18.9)"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M81.4,174.1l.8-.8a.9.9,0,0,1,1.2,0l2.1,1.7a.9.9,0,0,1,0,1.3h0l-.7.8a.9.9,0,0,1-1.3.1h0l-2-1.9a.8.8,0,0,1-.2-1.1Z",
    transform: "translate(0 -18.9)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M291.2,299.4H248.4a8.9,8.9,0,0,1-8.8-8.9V275.6a8.9,8.9,0,0,1,8.8-8.9h28.4l7-8.9-1,8.9h8.4a8.7,8.7,0,0,1,8.8,8.8h0v14.9a8.7,8.7,0,0,1-8.7,8.9Z",
    transform: "translate(0 -18.9)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M250.5,282.3a5.1,5.1,0,1,1,10.2,0h0a5.1,5.1,0,1,1-10.2,0Zm8.8,0a3.7,3.7,0,1,0-3.7,3.7,3.7,3.7,0,0,0,3.7-3.7Z",
    transform: "translate(0 -18.9)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M261.9,283.5a3.8,3.8,0,1,1,3.9,3.7h-.1a3.8,3.8,0,0,1-3.8-3.6Zm6.2,0a2.5,2.5,0,1,0-2.5,2.5h.1a2.4,2.4,0,0,0,2.4-2.4Z",
    transform: "translate(0 -18.9)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M278.7,283.5a3.5,3.5,0,0,1-3.3,3.7H275a3,3,0,0,1-2.5-1.2v3.7h-1.3v-9.8h1.3V281a3,3,0,0,1,2.5-1.2,3.5,3.5,0,0,1,3.7,3.3Zm-1.3,0a2.5,2.5,0,1,0-2.5,2.5,2.4,2.4,0,0,0,2.5-2.3v-.2Z",
    transform: "translate(0 -18.9)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.6,286.3l.5-1a5,5,0,0,0,2.6.8c1.2,0,1.7-.4,1.7-1s-4.6-.2-4.6-3.1c0-1.3,1.2-2.2,3-2.2a5.2,5.2,0,0,1,2.7.7l-.6,1a3.9,3.9,0,0,0-2.1-.6c-1.1,0-1.7.5-1.7,1s4.6.3,4.6,3.1-1.2,2.2-3.1,2.2A5.3,5.3,0,0,1,279.6,286.3Z",
    transform: "translate(0 -18.9)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M287,286.3a.9.9,0,1,1,.9.9h0A.9.9,0,0,1,287,286.3Zm.2-8.7h1.5l-.3,6.5h-1Z",
    transform: "translate(0 -18.9)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M291.3,186l37.1,8,.7-1.4c2.8-5.2,13.2-25,16.5-38.5a36.6,36.6,0,0,0,1-7.4c-.5-15-35.8-55.5-35.8-55.5l-7,16.1L320,146.8C306.9,162.1,291.3,186,291.3,186Z",
    transform: "translate(0 -18.9)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.3,186l37.1,8,.7-1.4c2.8-5.2,13.2-25,16.5-38.5a36.6,36.6,0,0,0,1-7.4c-.5-15-35.8-55.5-35.8-55.5l-7,16.1L320,146.8C306.9,162.1,291.3,186,291.3,186Z",
    transform: "translate(0 -18.9)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M248.7,223.3l-16.4,5.6-8.1,2.8-7.7,2.3-1.6.3-.7.2h-.8l-2-.2-8.5-1.1c-5.7-.7-11.6-1.5-17.6-1.9h-.1a5.4,5.4,0,0,0-5.9,4.9,5.5,5.5,0,0,0,2.8,5.2,115.2,115.2,0,0,0,16.6,8c2.9,1.1,5.8,2.2,8.8,3.1l2.4.7,1.2.3h6.1l2.9-.3c3.5-.5,6.6-1.2,9.6-1.9l9-2.4c5.9-1.8,11.6-3.6,17.3-5.9a10.7,10.7,0,0,0-7.2-20.1Z",
    transform: "translate(0 -18.9)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M248.7,223.3l-16.4,5.6-8.1,2.8-7.7,2.3-1.6.3-.7.2h-.8l-2-.2-8.5-1.1c-5.7-.7-11.6-1.5-17.6-1.9h-.1a5.4,5.4,0,0,0-5.9,4.9,5.5,5.5,0,0,0,2.8,5.2,115.2,115.2,0,0,0,16.6,8c2.9,1.1,5.8,2.2,8.8,3.1l2.4.7,1.2.3h6.1l2.9-.3c3.5-.5,6.6-1.2,9.6-1.9l9-2.4c5.9-1.8,11.6-3.6,17.3-5.9a10.7,10.7,0,0,0-7.2-20.1Z",
    transform: "translate(0 -18.9)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M214.2,234.5s4.2,13.2.6,19.4h2.4s3-12.4-2.3-19.5Z",
    transform: "translate(0 -18.9)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M182.9,231.2l-10.2-1.6,3.2,11s9.2.9,9.5-3.9Z",
    transform: "translate(0 -18.9)"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "163.2 214.6 169.2 223.1 175.9 221.7 172.7 210.7 163.2 214.6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M182.9,231.2l-10.2-1.6,3.2,11s9.2.9,9.5-3.9Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "163.2 214.6 169.2 223.1 175.9 221.7 172.7 210.7 163.2 214.6"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M182.9,231.2s2.6,6.1-2,9.3l1.2.9s6.3-1.8,3.2-10.1Z",
    transform: "translate(0 -18.9)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M214.2,234.5s4.2,13.2.6,19.4h2.4s3-12.4-2.3-19.5Z",
    transform: "translate(0 -18.9)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M182.9,231.2s2.6,6.1-2,9.3l1.2.9s6.3-1.8,3.2-10.1Z",
    transform: "translate(0 -18.9)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M311.2,97.4l-4.4,9.2c-.2.4-2.6.8-3,.7h0L293,103.4a2.1,2.1,0,0,1-1.3-2.7c0-.1.1-.1.1-.2,2-4.6,3.2-6.7,5.8-12.5,1.5-3.6,4.2-10.8,7-15.3s7.3-1.6,6.5.5c-1.9,5.2-1.5,13.5-.3,18C311,91.9,311.6,96.6,311.2,97.4Z",
    transform: "translate(0 -18.9)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M312,98.3l-6.2,8.9c-.2.5-1.6.2-2,.1h0L293,103.4a2.1,2.1,0,0,1-1.3-2.7c0-.1.1-.1.1-.2,2-4.6,3.2-6.7,5.8-12.5,1.5-3.6,4.2-10.8,7-15.3s7.3-1.6,6.5.5c-1.9,5.2-1.5,13.5-.3,18C311,91.9,312.3,97.5,312,98.3Z",
    transform: "translate(0 -18.9)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M329.1,192.6c2.8-5.2,13.2-25,16.5-38.5-4.9,4.5-16.2,16.1-21.5,30C321.4,190.9,324.2,193.3,329.1,192.6Z",
    transform: "translate(0 -18.9)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M291.8,192.3s9.3-20.7,33.2-18a555.5,555.5,0,0,1,49.1-31l5.7-60.5,13.7-2.5s12.7,50.3.7,77.3-65.1,54.6-65.1,54.6Z",
    transform: "translate(0 -18.9)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.8,192.3s9.3-20.7,33.2-18a555.5,555.5,0,0,1,49.1-31l5.7-60.5,13.7-2.5s12.7,50.3.7,77.3-65.1,54.6-65.1,54.6Z",
    transform: "translate(0 -18.9)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M336.3,181.1a8.1,8.1,0,0,1-9.5,5.6L299,180.6a8.1,8.1,0,0,1-6.3-7.7,12.1,12.1,0,0,1,.1-1.9c.1-.2.1-.4.2-.6a8.1,8.1,0,0,1,9.5-5.6l27.8,6.1a8.2,8.2,0,0,1,5.8,4.9,9.4,9.4,0,0,1,.4,4.7C336.4,180.7,336.4,180.9,336.3,181.1Z",
    transform: "translate(0 -18.9)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M335.7,178.2a8,8,0,0,1-9.4,5.6l-27.9-6.1a7.7,7.7,0,0,1-5.7-4.8,12.1,12.1,0,0,1,.1-1.9c.1-.2.1-.4.2-.6a8.1,8.1,0,0,1,9.5-5.6l27.8,6.1a8.2,8.2,0,0,1,5.8,4.9,12.3,12.3,0,0,1-.2,1.9C335.8,177.8,335.8,178,335.7,178.2Z",
    transform: "translate(0 -18.9)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M330.9,215s4.3-13.3-8.5-22.3-15.9,9.3-15.9,9.3L330,215.9Z",
    transform: "translate(0 -18.9)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M330.9,215s4.3-13.3-8.5-22.3-15.9,9.3-15.9,9.3L330,215.9Z",
    transform: "translate(0 -18.9)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M317.8,192.6s13.3,7.6,12.8,20.2-28.2,32.4-37.9,34.6-44.5-3.3-47.1-9.3c-8.9-20.5,28.4-38.7,40.4-42.3S317.8,192.6,317.8,192.6Z",
    transform: "translate(0 -18.9)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M245.6,238.1a2.2,2.2,0,0,0,.5.8c2.1,2.4,9.3,4.7,17.5,6.3,10.3,2.1,22.4,3.2,28.1,2.3h1c7.5-1.7,25.7-13.9,33.9-25.2,2.4-3.3,3.9-6.6,4-9.4.5-12.6-12.8-20.2-12.8-20.2s-19.8-.4-31.8,3.2S236.7,217.6,245.6,238.1Z",
    transform: "translate(0 -18.9)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M246.1,238.9c2.1,2.4,9.3,4.7,17.5,6.3,21.8-12.9,16.3-29.4,16.3-29.4C266.4,210.5,251,226.8,246.1,238.9Z",
    transform: "translate(0 -18.9)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M329.1,192.6s1.2-13.1-1.1-15.4-33.6-8.5-37.9-8.2-30.7,12.6-33.6,17.4-.5,20-.5,20,20.4,10.7,30.4,9.6S324.9,198.8,329.1,192.6Z",
    transform: "translate(0 -18.9)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M256,206.4s20.4,10.7,30.4,9.6,38.5-17.2,42.7-23.4c0,0,1.2-13.1-1.1-15.4s-33.6-8.5-37.9-8.2-30.7,12.6-33.6,17.4a11.5,11.5,0,0,0-1.3,4.8C254.6,197.5,256,206.4,256,206.4Z",
    transform: "translate(0 -18.9)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.2,191.2c2.8,1.4,20.9,10.4,30.1,9.4s38.4-17.3,42.7-23.4c-2.4-2.3-33.6-8.5-37.9-8.2s-30.7,12.6-33.6,17.4A11.5,11.5,0,0,0,255.2,191.2Z",
    transform: "translate(0 -18.9)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 249.3,
    cy: 195.3,
    r: 29.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 249.3,
    cy: 195.3,
    r: 29.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M251.6,242.1a28.3,28.3,0,1,0-30.3-26.2A28.3,28.3,0,0,0,251.6,242.1Z",
    transform: "translate(0 -18.9)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "s",
    cx: 261.4,
    cy: 221.8,
    rx: 21.3,
    ry: 15.9,
    transform: "translate(-62 316.7) rotate(-59.7)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.3,229.2s3.7,6.8,5.7,5.9,3.8,4.1,7.1,2.5,10.1-6.7,9.5-13.7S252.5,219.9,249.3,229.2Z",
    transform: "translate(0 -18.9)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M249.3,229.2s3.7,6.8,5.7,5.9a1.8,1.8,0,0,1,1.7.4c1.4,1,3,3.3,5.4,2.1s10.1-6.7,9.5-13.7c-.3-3-3.9-4.2-8.1-3.8l-3.4.6c-4.5,1.2-9,4-10.7,8C249.4,228.9,249.3,229,249.3,229.2Z",
    transform: "translate(0 -18.9)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M249.3,229.2s3.7,6.8,5.7,5.9a1.8,1.8,0,0,1,1.7.4c7.4-2,7.2-11.8,6.8-15.4l-3.4.6c-3.1,2-7.9,5.1-10.7,8C249.4,228.9,249.3,229,249.3,229.2Z",
    transform: "translate(0 -18.9)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M238,225.4l.6.2c5.5,1.3,7.2-10,6.3-17-.3-3.1-1.5-4.8-3-5.3s-3.9.7-5.1,3.7-.3,5.2-.9,6.5S233.2,223.6,238,225.4Z",
    transform: "translate(0 -18.9)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M238,225.4l.6.2c5.5,1.3,7.2-10,6.3-17-.3-3.1-1.5-4.8-3-5.3s-3.9.7-5.1,3.7-.3,5.2-.9,6.5S233.2,223.6,238,225.4Z",
    transform: "translate(0 -18.9)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M238,225.4l.6.2c5.5,1.3,7.2-10,6.3-17-.3-3.1-1.5-4.8-3-5.3l-1.4.7c-2.3,1.2-2.5,8.7-3.1,10.5S235.8,221.8,238,225.4Z",
    transform: "translate(0 -18.9)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M262.8,212.7c-.3,8.8,0,14-4.3,18.6-6.6,6.9-17.6,3.1-19.9-5.7s-1.3-21,7.3-24.6a12.1,12.1,0,0,1,15.9,6.3A11.1,11.1,0,0,1,262.8,212.7Z",
    transform: "translate(0 -18.9)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.5,215.4c0,.7-.3,1.3-.8,1.3s-.9-.5-.9-1.3.4-1.3.8-1.3S249.5,214.7,249.5,215.4Z",
    transform: "translate(0 -18.9)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M241.4,215.5a1.2,1.2,0,0,1-.8,1.4c-.5,0-.9-.6-.9-1.3s.3-1.3.8-1.3S241.4,214.8,241.4,215.5Z",
    transform: "translate(0 -18.9)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M244,215.9a23.2,23.2,0,0,1-3.4,5.9c1.3,1.1,3.5.6,3.5.6Z",
    transform: "translate(0 -18.9)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M248.7,210.4l.4.2a3.7,3.7,0,0,0,2.7,1.3h.4a.4.4,0,0,1,.1.3c0,.3-.1.5-.3.5a4.2,4.2,0,0,1-3.6-1.6.5.5,0,0,1,.1-.6Z",
    transform: "translate(0 -18.9)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M240.5,210h.3c.2.1.2.2.2.4h-.1a4.1,4.1,0,0,1-3.3,2,.4.4,0,0,1,0-.8h0a3.3,3.3,0,0,0,2.6-1.6Z",
    transform: "translate(0 -18.9)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249,228.3h-.7l-3.3-3.2.5-.4c1.2-.9,3.8-2.7,5.6-2l.5.3a2.9,2.9,0,0,1,1.3,1.8C253.2,226,252.4,227.3,249,228.3Z",
    transform: "translate(0 -18.9)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M251.6,223.1l-5.6,2-.5-.3c1.2-.9,3.8-2.7,5.6-2Z",
    transform: "translate(0 -18.9)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M249,228.3c-.2-1.9,2.3-3,3.9-3.4C253.2,226,252.4,227.3,249,228.3Z",
    transform: "translate(0 -18.9)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M259.3,224.8s-5,5.2-6.7,6.2-5.9,1.2-5.9,1.2",
    transform: "translate(0 -18.9)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M246.7,233H248a.9.9,0,0,0,.8-.9h0a.9.9,0,0,0-.8-.8h-1.4a.9.9,0,0,0-.8.8h0A.9.9,0,0,0,246.7,233Z",
    transform: "translate(0 -18.9)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M266.4,220a8.2,8.2,0,0,1-4,4.9c-2.6,1.4-4.5-.8-4.4-3.5s1.7-6.3,4.6-6.5a3.8,3.8,0,0,1,4,3.6A2.6,2.6,0,0,1,266.4,220Z",
    transform: "translate(0 -18.9)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M245.3,203.9c2.8,0,9.6.8,10.7,2.5s-.6,18.6,2.4,20.5,10.3-1.8,11.2-6.8a10.9,10.9,0,0,0-1.4-8.1s2.9-13-10.6-15.8-19.9,6.9-20.8,10.8A14.5,14.5,0,0,1,245.3,203.9Z",
    transform: "translate(0 -18.9)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M245.3,203.9c2.8,0,9.6.8,10.7,2.5s-.6,18.6,2.4,20.5,10.3-1.8,11.2-6.8a10.9,10.9,0,0,0-1.4-8.1s2.9-13-10.6-15.8-19.9,6.9-20.8,10.8A14.5,14.5,0,0,1,245.3,203.9Z",
    transform: "translate(0 -18.9)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M239.8,184.9h1.9a34.4,34.4,0,0,1,18,0c10.3,2.6,22.6,16.2,19.9,34.8a14.2,14.2,0,0,1-.4,2l-.3,1.5h0a10.7,10.7,0,0,1-.7,1.9c-4.1,10.5-15.3,15.9-15.3,15.9a34.7,34.7,0,0,1-13.7,3.8l-1.7-1.7c20.4-2,23.5-22.9,23.5-22.9l-2.8-13.5s-11-23.8-33.9-18.4l-.6-.9A35.6,35.6,0,0,1,239.8,184.9Z",
    transform: "translate(0 -18.9)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M233.7,187.6l.6.9c22.9-5.4,33.9,18.4,33.9,18.4l2.8,13.5s-3.1,20.9-23.5,22.9l1.7,1.8a38.3,38.3,0,0,0,5.9-1,31.9,31.9,0,0,0,7.8-2.9s11.2-5.4,15.3-15.9a10.7,10.7,0,0,0,.7-1.9h0l.3-1.5a14.2,14.2,0,0,0,.4-2c2.7-18.6-9.6-32.2-19.9-34.8a35,35,0,0,0-17.9-.1h-2A46.6,46.6,0,0,0,233.7,187.6Z",
    transform: "translate(0 -18.9)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M233.7,187.6l.6.9c22.9-5.4,33.9,18.4,33.9,18.4l2.8,13.5s-3.1,20.9-23.5,22.9l1.7,1.8a38.3,38.3,0,0,0,5.9-1c6.2-3,18.3-14.2,16.9-22.7a79.3,79.3,0,0,1-1.2-15.4s-9.9-20.4-29-21.1h-2A36.6,36.6,0,0,0,233.7,187.6Z",
    transform: "translate(0 -18.9)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M269.8,205.9c2.1-.2,4.2,1.3,5.5,3.6a8.2,8.2,0,0,1,2.8,5.8,8.7,8.7,0,0,1-1.9,6.2c-1,2.5-2.8,4.2-5,4.4s-6.9-4-7.3-9.5S266.1,206.2,269.8,205.9Z",
    transform: "translate(0 -18.9)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M269.8,205.9c2.1-.2,4.2,1.3,5.5,3.6a8.2,8.2,0,0,1,2.8,5.8,8.7,8.7,0,0,1-1.9,6.2c-1,2.5-2.8,4.2-5,4.4s-6.9-4-7.3-9.5S266.1,206.2,269.8,205.9Z",
    transform: "translate(0 -18.9)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M268.9,216c.3,3.8,2.6,6.8,5.1,6.6s4.3-3.4,4.1-7.3-2.6-6.7-5.1-6.5S268.6,212.2,268.9,216Z",
    transform: "translate(0 -18.9)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M231.1,195.5a60.2,60.2,0,0,1,5.6,3,38.5,38.5,0,0,1,11.1-6s-2.6-2.3-8.8-2.7A26.1,26.1,0,0,0,231.1,195.5Z",
    transform: "translate(0 -18.9)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M223.5,216.3A41.8,41.8,0,0,1,235,199.9l-4.6-3.6C226.4,200.9,222.4,207.8,223.5,216.3Z",
    transform: "translate(0 -18.9)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M394,83.1l-13.9,4.1a1,1,0,0,1-1.1-.5h0L375.1,76a2.2,2.2,0,0,1,1.4-2.8h.1l13.3-3.5c3.7-1.1,11-3.6,16.3-4.3s5.9,4.6,3.7,5.4c-5.2,1.8-11.4,7.4-14,11.1A3.9,3.9,0,0,1,394,83.1Z",
    transform: "translate(0 -18.9)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M394,83.1l-13.9,4.1a1,1,0,0,1-1.1-.5h0L375.1,76a2.2,2.2,0,0,1,1.4-2.8h.1l13.3-3.5c3.7-1.1,11-3.6,16.3-4.3s5.9,4.6,3.7,5.4c-5.2,1.8-11.4,7.4-14,11.1A3.9,3.9,0,0,1,394,83.1Z",
    transform: "translate(0 -18.9)"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "395.4 63.4 395.6 66.1 378.6 69.1 378.4 66.9 395.4 63.4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M310.6,90.7s.3,12.2-7.7,16.7l1.7,1.9s9.8-5.4,8.1-16.6Z",
    transform: "translate(0 -18.9)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M373.1,143.9l1.1-2.2s11.8-3.8,22.9,7.3l-1.4,4.8S386.7,142.8,373.1,143.9Z",
    transform: "translate(0 -18.9)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M346.3,143.4s-16.9,12.7-27.2,4.4l.3-2.4s9.5,7,25.4-5.5Z",
    transform: "translate(0 -18.9)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M291.7,247.5h1c7.5-1.7,25.7-13.9,33.9-25.2-7.4-.2-26.3-.2-33.2,3.4S284.6,243.3,291.7,247.5Z",
    transform: "translate(0 -18.9)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M310.6,90.7s.3,12.2-7.7,16.7l1.7,1.9s9.8-5.4,8.1-16.6Z",
    transform: "translate(0 -18.9)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M346.3,143.4s-16.9,12.7-27.2,4.4l.3-2.4s9.5,7,25.4-5.5Z",
    transform: "translate(0 -18.9)"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "395.4 63.4 395.6 66.1 378.6 69.1 378.4 66.9 395.4 63.4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M373.1,143.9l1.1-2.2s11.8-3.8,22.9,7.3l-1.4,4.8S386.7,142.8,373.1,143.9Z",
    transform: "translate(0 -18.9)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M320.5,194.5s21,34.1-3.5,39.6",
    transform: "translate(0 -18.9)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M312.3,201.4s18.4,23.5.8,38.7",
    transform: "translate(0 -18.9)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M292.8,246.9l17.3.8,8.6.5c2.8.1,5.6.4,7.9.7l1.6.2h.7l-.3-.3h.2l.9.5,1.8.9,7.5,4.1c5.1,2.8,10.2,5.8,15.7,8.4h0a5.5,5.5,0,0,0,7.3-2.6,5.4,5.4,0,0,0-.6-5.6,123.6,123.6,0,0,0-12.5-13.6c-2.2-2.1-4.6-4.1-7.1-6.2l-1.9-1.5-1-.7-.3-.2h-.1l-.3-.2-1.4-.7-3.5-1.3-2.8-.8a78.9,78.9,0,0,0-9.7-1.8c-3.1-.5-6.1-.8-9.2-1.1-6.1-.6-12.1-.9-18.2-.9A10.5,10.5,0,0,0,282.7,236h0a10.7,10.7,0,0,0,9.9,10.7Z",
    transform: "translate(0 -18.9)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M292.8,246.9l17.3.8,8.6.5c2.8.1,5.6.4,7.9.7l1.6.2h.7l-.3-.3h.2l.9.5,1.8.9,7.5,4.1c5.1,2.8,10.2,5.8,15.7,8.4h0a5.5,5.5,0,0,0,7.3-2.6,5.4,5.4,0,0,0-.6-5.6,123.6,123.6,0,0,0-12.5-13.6c-2.2-2.1-4.6-4.1-7.1-6.2l-1.9-1.5-1-.7-.3-.2h-.1l-.3-.2-1.4-.7-3.5-1.3-2.8-.8a78.9,78.9,0,0,0-9.7-1.8c-3.1-.5-6.1-.8-9.2-1.1-6.1-.6-12.1-.9-18.2-.9A10.5,10.5,0,0,0,282.7,236h0a10.7,10.7,0,0,0,9.9,10.7Z",
    transform: "translate(0 -18.9)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M359.2,255.4l10.2,2-6.8,9.2s-9-2.3-7.6-6.8Z",
    transform: "translate(0 -18.9)"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "377 245.5 368.4 251.4 362.6 247.8 369.4 238.6 377 245.5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M359.2,255.4l10.2,2-6.8,9.2s-9-2.3-7.6-6.8Z",
    transform: "translate(0 -18.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "377 245.5 368.4 251.4 362.6 247.8 369.4 238.6 377 245.5"
  }))), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M362.4,256s-6.3,1.3-6.3,7.3l-2.3-.8s-1.1-6.3,7.6-7.8Z",
    transform: "translate(0 -18.9)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M296,225.3s-18.8,8-4.5,21.4l-2.2.2s-9-3.1-6.3-13.4S296,225.3,296,225.3Z",
    transform: "translate(0 -18.9)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M336.8,231.5s-7.2,5.2-7.9,17.7l-1.4-.2a25.4,25.4,0,0,1,7.7-18.2Z",
    transform: "translate(0 -18.9)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M362.4,256s-6.3,1.3-6.3,7.3l-2.3-.8s-1.1-6.3,7.6-7.8Z",
    transform: "translate(0 -18.9)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296,225.3s-18.8,8-4.5,21.4l-2.2.2s-9-3.1-6.3-13.4S296,225.3,296,225.3Z",
    transform: "translate(0 -18.9)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M336.8,231.5s-7.2,5.2-7.9,17.7l-1.4-.2a25.4,25.4,0,0,1,7.7-18.2Z",
    transform: "translate(0 -18.9)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M317.9,179.1l-29.5,15.3-8-2.3,29.8-15.2S315.7,175.2,317.9,179.1Z",
    transform: "translate(0 -18.9)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M317.9,179.1l-29.5,15.3a6.1,6.1,0,0,0-8-2.3l29.8-15.2S315.7,175.2,317.9,179.1Z",
    transform: "translate(0 -18.9)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M291.8,173.6a3.2,3.2,0,0,1-1.4.3,8.1,8.1,0,0,1-2.2-.1c-.9-.3-1.4-.7-1.5-1.3s.6-1.3,1.8-1.8l1.5-.3a5,5,0,0,1,2.1.1c1,.2,1.6.6,1.7,1.2S293,173.2,291.8,173.6Z",
    transform: "translate(0 -18.9)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M259.2,70.2s2.9.3,4.4-1",
    transform: "translate(0 -18.9)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M258.8,71.5a20.5,20.5,0,0,1,7.8-.3",
    transform: "translate(0 -18.9)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M263.9,72.6s-1.3-1.3-5.2-.6",
    transform: "translate(0 -18.9)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M291.8,173.6a3.2,3.2,0,0,1-1.4.3,8.1,8.1,0,0,1-2.2-.1c.1-.8.2-1.8.3-3.1.2-3.2,0-7.6-2-11.4-5.4-9.9-14.3-13.2-23.7-16.7s-18.4-6.7-25-16.2-7.3-24.2-1.4-37.1,14.5-19.1,24.5-20.1l.4,3.6c-8.8.8-16.9,7.6-21.6,18s-5,25,1,33.6S255.1,136,264,139.3s19.6,7.2,25.6,18.4c2.3,4.2,2.6,9.1,2.5,12.8C292,171.7,291.9,172.8,291.8,173.6Z",
    transform: "translate(0 -18.9)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M291.8,173.6a3.2,3.2,0,0,1-1.4.3,8.1,8.1,0,0,1-2.2-.1c.1-.8.2-1.8.3-3.1.2-3.2,0-7.6-2-11.4-5.4-9.9-14.3-13.2-23.7-16.7s-18.4-6.7-25-16.2-7.3-24.2-1.4-37.1,14.5-19.1,24.5-20.1l.4,3.6c-8.8.8-16.9,7.6-21.6,18s-5,25,1,33.6S255.1,136,264,139.3s19.6,7.2,25.6,18.4c2.3,4.2,2.6,9.1,2.5,12.8C292,171.7,291.9,172.8,291.8,173.6Z",
    transform: "translate(0 -18.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.c81075d52b4d40abe0e252c4f4f4afaa.svg";
export { ForwardRef as ReactComponent };